/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useRef } from "react";
import { supabase } from "../supabaseClient";
import axios from "axios";
import toast from "react-hot-toast";
import { API_URL } from "../config";
import { useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import { getLookupPiyasalar, getLookupParaBirimleri, getLookupPeriyotlar } from "./apiCache";

const C = {
    bg:"#0f172a", panel:"#1e293b", border:"#334155", text:"#e2e8f0",
    muted:"#94a3b8", accent:"#3b82f6", bullish:"#16a34a", bearish:"#dc2626",
    warning:"#f59e0b", teal:"#0d9488", gold:"#eab308",
};

// ─── Bilgi İçerikleri ─────────────────────────────────────────────────────────
const BILGI_ICERIK = {
    "TOLERANS": {
        baslik: "Tolerans (Temas Hareketi)",
        icerik: "Bir temasın geçerli sayılması için FVG orta noktasından uzaklaşılması gereken minimum fiyat hareketi yüzdesi.\n• %30: Orta noktadan %30 uzaklaşınca temas geçerli\n• %100: Orta noktanın tam 2 katına / yarısına ulaşılması gerekir\nDüşük tolerans → daha fazla temas, yüksek tolerans → daha güvenilir temas.",
    },
    "Alt Sınır": {
        baslik: "FVG Alt Sınırı",
        icerik: "Yıllık FVG (Fair Value Gap) bölgesinin alt fiyat sınırı.\n• Boğa FVG: 1. yıllık mumun High'ı\n• Ayı FVG: 3. yıllık mumun High'ı\nGüncel fiyat bu seviyenin üzerinde ve Üst Sınırın altındaysa FVG bölgesi içindedir.",
    },
    "Üst Sınır": {
        baslik: "FVG Üst Sınırı",
        icerik: "Yıllık FVG bölgesinin üst fiyat sınırı.\n• Boğa FVG: 3. yıllık mumun Low'u\n• Ayı FVG: 1. yıllık mumun Low'u\nFiyat Alt Sınır ile Üst Sınır arasındaysa çapa noktası aktif demektir.",
    },
    "Temas Sayısı": {
        baslik: "Temas Sayısı",
        icerik: "FVG bölgesine aylık mumlarla kaç kez temas edildiğini gösterir. 3 adımlı state machine ile sayılır:\n1. Fiyat FVG bölgesine girer\n2. Orta noktadan tolerans kadar uzaklaşır\n3. FVG bölgesine geri döner → 1 temas\nYüksek temas sayısı = çapa noktasının defalarca test edildiğini gösterir.",
    },
    "Çapa Durum": {
        baslik: "Çapa Noktası Durumu",
        icerik: "• 🎯 Temas aşıldı (≥3 temas): FVG bölgesi en az 3 kez test edilmiş — güçlü çapa noktası\n• 👀 İzleniyor (1-2 temas): Bölge test edilmeye başlanmış ama henüz yeterli teyit yok\nYüksek temas sayılı çapa noktaları daha güvenilir destek/direnç seviyeleri olarak değerlendirilebilir.",
    },
};

function BilgiIkonu({ alan }) {
    const [acik, setAcik] = useState(false);
    const bilgi = BILGI_ICERIK[alan];
    if (!bilgi) return null;
    return (
        <span style={{position:"relative",display:"inline-flex",alignItems:"center",marginLeft:4}}>
            <span
                onMouseEnter={() => setAcik(true)}
                onMouseLeave={() => setAcik(false)}
                style={{cursor:"help",color:C.muted,fontSize:11,
                    border:`1px solid ${C.border}`,borderRadius:"50%",
                    width:14,height:14,display:"inline-flex",alignItems:"center",
                    justifyContent:"center",fontWeight:700,lineHeight:1}}>
                i
            </span>
            {acik && (
                <div style={{
                    position:"absolute",top:"calc(100% + 6px)",left:"50%",
                    transform:"translateX(-50%)",zIndex:500,
                    background:"#1e293b",border:`1px solid ${C.border}`,
                    borderRadius:10,padding:"12px 14px",width:270,
                    boxShadow:"0 8px 24px rgba(0,0,0,0.5)",pointerEvents:"none",
                }}>
                    <div style={{fontSize:12,fontWeight:700,color:C.accent,marginBottom:6}}>{bilgi.baslik}</div>
                    <div style={{fontSize:11,color:C.muted,lineHeight:1.6,whiteSpace:"pre-line"}}>{bilgi.icerik}</div>
                </div>
            )}
        </span>
    );
}

// ─── Hareketli Yükleme Çubuğu ────────────────────────────────────────────────
function HareketliBar() {
    const [offset, setOffset] = useState(0);
    useEffect(() => {
        const id = setInterval(() => setOffset(o => (o+3)%200), 20);
        return () => clearInterval(id);
    }, []);
    const pos = offset<=100 ? offset-100 : 200-offset-100;
    return (
        <div style={{height:8,background:C.bg,borderRadius:4,overflow:"hidden",
            border:`1px solid ${C.border}`,marginBottom:16,position:"relative"}}>
            <div style={{position:"absolute",top:0,height:"100%",width:"40%",
                left:`${50+pos*0.5}%`,
                background:"linear-gradient(90deg,transparent,#3b82f6,#06b6d4,#3b82f6,transparent)",
                borderRadius:4}}/>
        </div>
    );
}

// ─── İlerleme Paneli ─────────────────────────────────────────────────────────
function TaramaIlerlemePaneli({ilerleme,tamamlanan,toplam,bulunan,gecen,tahminiSure}) {
    const fmt = sn => {
        if(!sn||sn<=0) return "—";
        const m=Math.floor(sn/60),s=sn%60;
        return m===0?`${s}s`:`${String(m).padStart(2,"0")}:${String(s).padStart(2,"0")}`;
    };
    let kalan = tahminiSure||null;
    if(!kalan&&tamamlanan>0&&gecen>0&&toplam>0)
        kalan = Math.round((gecen/tamamlanan)*(toplam-tamamlanan));
    return (
        <div style={{marginBottom:16,background:C.panel,border:`2px solid ${C.accent}44`,
            borderRadius:12,padding:20,boxShadow:`0 0 20px ${C.accent}18`}}>
            <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:14}}>
                <span style={{fontSize:20}}>⚓</span>
                <span style={{fontSize:15,fontWeight:700,color:C.text}}>Çapa Noktası Tarama Çalışıyor</span>
                <span style={{marginLeft:"auto",fontSize:22,fontWeight:800,color:C.accent}}>%{ilerleme}</span>
            </div>
            <div style={{height:10,background:C.bg,borderRadius:6,overflow:"hidden",
                marginBottom:10,border:`1px solid ${C.border}`}}>
                <div style={{height:"100%",width:`${ilerleme}%`,
                    background:`linear-gradient(90deg,${C.accent},#06b6d4)`,
                    borderRadius:6,transition:"width 0.5s ease"}}/>
            </div>
            <div style={{display:"flex",gap:24,flexWrap:"wrap"}}>
                <div>
                    <div style={{fontSize:10,color:C.muted,marginBottom:2}}>TAMAMLANAN</div>
                    <div style={{fontSize:16,fontWeight:700,color:C.accent}}>
                        {toplam>0?`${tamamlanan.toLocaleString("tr-TR")} / ${toplam.toLocaleString("tr-TR")}`:"—"}
                    </div>
                </div>
                <div>
                    <div style={{fontSize:10,color:C.muted,marginBottom:2}}>BULUNAN</div>
                    <div style={{fontSize:16,fontWeight:700,color:C.bullish}}>
                        {bulunan>0?bulunan.toLocaleString("tr-TR"):"—"}
                    </div>
                </div>
                <div>
                    <div style={{fontSize:10,color:C.muted,marginBottom:2}}>GEÇEN SÜRE</div>
                    <div style={{fontSize:16,fontWeight:700,color:C.teal}}>{fmt(gecen)}</div>
                </div>
                <div>
                    <div style={{fontSize:10,color:C.muted,marginBottom:2}}>TAHMİNİ KALAN</div>
                    <div style={{fontSize:16,fontWeight:700,color:C.gold}}>
                        {kalan!=null?fmt(kalan):(tamamlanan===0?"Hesaplanıyor...":"—")}
                    </div>
                </div>
            </div>
        </div>
    );
}

// ─── İndir Alt Menüsü ─────────────────────────────────────────────────────────
function IndirMenusu({sonuc,siralanmisVeri,setIslemMenuAcik}) {
    const [acik,setAcik] = useState(false);
    const dosyaAdi = `capa_tarama_${new Date().toLocaleDateString("tr-TR").replace(/\./g,"-")}`;
    const indir = async (fmt) => {
        setAcik(false); setIslemMenuAcik(false);
        if(!siralanmisVeri?.length) return;
        const veri = siralanmisVeri;
        if(fmt==="xlsx") {
            const ws=XLSX.utils.json_to_sheet(veri);
            const wb=XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb,ws,"Çapa Tarama");
            XLSX.writeFile(wb,`${dosyaAdi}.xlsx`);
        } else if(fmt==="csv") {
            const h=Object.keys(veri[0]||{});
            const rows=veri.map(r=>h.map(k=>{const v=String(r[k]??"");return v.includes(",")||v.includes('"')?`"${v.replace(/"/g,'""')}"`:v;}).join(","));
            const blob=new Blob(["\uFEFF"+[h.join(","),...rows].join("\n")],{type:"text/csv;charset=utf-8;"});
            const url=URL.createObjectURL(blob);
            const a=document.createElement("a");a.href=url;a.download=`${dosyaAdi}.csv`;a.click();URL.revokeObjectURL(url);
        } else if(fmt==="pdf") {
            try {
                const{default:jsPDF}=await import("jspdf");
                const{default:autoTable}=await import("jspdf-autotable");
                const h=Object.keys(veri[0]||{});
                const doc=new jsPDF({orientation:"landscape",unit:"pt",format:"a4"});
                doc.setFontSize(14);doc.text("Çapa Noktası Tarama Sonuçları",20,30);
                doc.setFontSize(9);doc.setTextColor(100);
                doc.text(`${veri.length} kayıt · ${new Date().toLocaleDateString("tr-TR")}`,20,48);
                autoTable(doc,{head:[h],body:veri.map(r=>h.map(k=>String(r[k]??""))),startY:58,
                    styles:{fontSize:7,cellPadding:3},
                    headStyles:{fillColor:[29,78,216],textColor:255,fontStyle:"bold"},
                    alternateRowStyles:{fillColor:[245,247,250]}});
                doc.save(`${dosyaAdi}.pdf`);
            } catch{toast.error("PDF oluşturulamadı");indir("svg");}
        } else if(fmt==="svg") {
            const h=Object.keys(veri[0]||{});
            const cw=Math.max(60,Math.floor(740/h.length)),rh=18,hh=24,tw=cw*h.length;
            const pw=Math.max(tw+40,800),ph=80+hh+veri.length*rh;
            const esc=s=>String(s).slice(0,18).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;");
            const rows=veri.map((r,i)=>`<g transform="translate(20,${60+hh+i*rh})"><rect width="${tw}" height="${rh}" fill="${i%2===0?"#1e293b":"#0f172a"}" stroke="#334155" stroke-width="0.5"/>${h.map((k,j)=>`<text x="${j*cw+4}" y="13" font-size="9" fill="#e2e8f0" font-family="Arial">${esc(r[k])}</text>`).join("")}</g>`).join("");
            const heads=h.map((k,j)=>`<text x="${20+j*cw+4}" y="48" font-size="9" font-weight="bold" fill="white" font-family="Arial">${esc(k)}</text>`).join("");
            const svg=`<svg xmlns="http://www.w3.org/2000/svg" width="${pw}" height="${ph}"><rect width="${pw}" height="${ph}" fill="#0f172a"/><text x="20" y="22" font-size="14" font-weight="bold" fill="#e2e8f0" font-family="Arial">Çapa Noktası Tarama Sonuçları</text><text x="20" y="38" font-size="10" fill="#94a3b8" font-family="Arial">${veri.length} kayıt · ${new Date().toLocaleDateString("tr-TR")}</text><rect x="20" y="52" width="${tw}" height="${hh}" fill="#1d4ed8"/>${heads}${rows}</svg>`;
            const blob=new Blob([svg],{type:"image/svg+xml"});
            const url=URL.createObjectURL(blob);
            const a=document.createElement("a");a.href=url;a.download=`${dosyaAdi}.svg`;a.click();URL.revokeObjectURL(url);
        }
    };
    return (
        <div style={{position:"relative"}} onMouseEnter={()=>setAcik(true)} onMouseLeave={()=>setAcik(false)}>
            <button style={{display:"flex",width:"100%",textAlign:"left",justifyContent:"space-between",
                padding:"10px 16px",border:"none",background:"none",cursor:"pointer",
                color:C.text,fontSize:13,borderBottom:`1px solid ${C.border}`}}>
                📥 İndir <span style={{color:C.muted}}>▶</span>
            </button>
            {acik&&(
                <div style={{position:"absolute",left:"100%",top:0,background:C.panel,
                    border:`1px solid ${C.border}`,borderRadius:8,
                    boxShadow:"0 8px 24px rgba(0,0,0,0.4)",minWidth:160,overflow:"hidden",zIndex:101}}>
                    {[{l:"Excel (.xlsx)",f:"xlsx"},{l:"CSV (.csv)",f:"csv"},{l:"PDF (.pdf)",f:"pdf"},{l:"SVG (.svg)",f:"svg"}].map(s=>(
                        <button key={s.f} onClick={()=>indir(s.f)}
                            style={{display:"block",width:"100%",textAlign:"left",padding:"9px 14px",
                                border:"none",background:"none",cursor:"pointer",color:C.text,fontSize:13,
                                borderBottom:`1px solid ${C.border}`}}>{s.l}</button>
                    ))}
                </div>
            )}
        </div>
    );
}


export default function CapaTarama() {
    const navigate = useNavigate();

    const [piyasa,        setPiyasa]        = useState("BIST");
    const [paraBirimi,    setParaBirimi]    = useState("USD");
    const [fvgTipler,     setFvgTipler]     = useState({"Boğa FVG":true,"Ayı FVG":false});
    const [tolerans,      setTolerans]      = useState(30);
    const [sonuc,         setSonuc]         = useState(null);
    const [calisiyor,     setCalisiyor]     = useState(false);
    const [ilerleme,      setIlerleme]      = useState(0);
    const [tahminiSure,   setTahminiSure]   = useState(null);
    const [gecenSure,     setGecenSure]     = useState(0);
    const [bulunanSayisi, setBulunanSayisi] = useState(0);
    const [tamamlananSayisi,setTamamlananSayisi] = useState(0);
    const [toplamSayisi,  setToplamSayisi]  = useState(0);
    const [siralamaKol,   setSiralamaKol]   = useState(null);
    const [siralamaYon,   setSiralamaYon]   = useState("desc");
    const [secilenler,    setSecilenler]    = useState(new Set());
    const [islemMenuAcik, setIslemMenuAcik] = useState(false);
    const [dogrulukKaydediliyor,setDogrulukKaydediliyor] = useState(false);
    const [dogrulukPopup, setDogrulukPopup] = useState(null);
    const [dogrulukSonuc, setDogrulukSonuc] = useState(null);
    const [alarmPopup,    setAlarmPopup]    = useState(false);
    const [alarmHisseler, setAlarmHisseler] = useState([]);
    const [hedefFiyatlar, setHedefFiyatlar] = useState({});
    const [alarmMail,     setAlarmMail]     = useState(false);
    const [alarmBildirim, setAlarmBildirim] = useState(true);
    const [alarmKaydediliyor,setAlarmKaydediliyor] = useState(false);
    const [puanlamaPopupAdim,setPuanlamaPopupAdim] = useState(null);
    const [puanlamaVade,  setPuanlamaVade]  = useState(null);
    const [puanlamaYon,   setPuanlamaYon]   = useState(new Set(["Long","Short"]));
    const [puanlamaMinPuan,setPuanlamaMinPuan] = useState(0);
    const [cokluPopup,    setCokluPopup]    = useState(false);
    const [cokluSecModul, setCokluSecModul] = useState(null);
    const [cokluFiltre,   setCokluFiltre]   = useState(null);
    const [cokluOnayPopup,setCokluOnayPopup]= useState(false);
    const [cokluPeriyotlar,setCokluPeriyotlar] = useState([]);
    const [gecmisPopupAdim,setGecmisPopupAdim] = useState(null);
    const [gecmisSimTarihi,setGecmisSimTarihi] = useState(()=>{
        const d=new Date(); d.setFullYear(d.getFullYear()-1); return d.toISOString().split("T")[0];
    });
    const [gecmisRefFiyat,setGecmisRefFiyat] = useState("Bugünkü");

    const [piyasaSecenekleri,    setPiyasaSecenekleri]    = useState(["BIST","Kripto"]);
    const [paraBirimiSecenekleri,setParaBirimiSecenekleri]= useState(["USD","TL","BIST100 (TL)","BIST100 (USD)"]);

    const intervalRef  = useRef(null);
    const gecenRef     = useRef(null);
    const baslangicRef = useRef(null);

    const toggleFvgTip = tip => setFvgTipler(p=>({...p,[tip]:!p[tip]}));
    const seciliFvgTipler = Object.keys(fvgTipler).filter(t=>fvgTipler[t]);
    const tipRenk = tip => tip==="Boğa FVG"?C.bullish:C.bearish;

    const getToken = async () => {
        const{data:{session}}=await supabase.auth.getSession();
        return session?.access_token;
    };

    useEffect(()=>()=>{clearInterval(intervalRef.current);clearInterval(gecenRef.current);},[]);

    useEffect(()=>{
        const yukle = async () => {
            try {
                const [p,pb] = await Promise.all([
                    getLookupPiyasalar(),
                    getLookupParaBirimleri(piyasa,"capa_noktasi_tarama"),
                ]);
                setPiyasaSecenekleri(p);
                setParaBirimiSecenekleri(pb);
                if(pb.length>0&&!pb.includes(paraBirimi)) setParaBirimi(pb[0]);
            } catch{}
        };
        yukle();
    },[]);

    useEffect(()=>{
        getLookupParaBirimleri(piyasa,"capa_noktasi_tarama")
            .then(pb=>{setParaBirimiSecenekleri(pb);if(pb.length>0&&!pb.includes(paraBirimi))setParaBirimi(pb[0]);})
            .catch(()=>{});
    },[piyasa]);

    const taramaBaslat = async () => {
        if(seciliFvgTipler.length===0){toast.error("En az bir FVG tipi seçin");return;}
        setSonuc(null);setCalisiyor(true);setIlerleme(0);setTahminiSure(null);
        setGecenSure(0);setBulunanSayisi(0);setTamamlananSayisi(0);setToplamSayisi(0);
        baslangicRef.current=Date.now();
        clearInterval(gecenRef.current);
        gecenRef.current=setInterval(()=>setGecenSure(Math.floor((Date.now()-baslangicRef.current)/1000)),1000);
        try {
            const token=await getToken();
            await axios.post(`${API_URL}/scan/capa-tara`,{
                mod:        piyasa,
                fvg_tipler: seciliFvgTipler,
                para_birimi:paraBirimi,
                tolerans:   tolerans/100,
            },{headers:{Authorization:`Bearer ${token}`}});
            intervalRef.current=setInterval(durumSorgula,3000);
        } catch(e){
            toast.error(e.response?.data?.detail||"Hata oluştu");
            setCalisiyor(false);clearInterval(gecenRef.current);
        }
    };

    const durumSorgula = async () => {
        try {
            const{data:{session}}=await supabase.auth.getSession();
            if(!session){clearInterval(intervalRef.current);return;}
            const res=await axios.get(`${API_URL}/scan/durum`,{headers:{Authorization:`Bearer ${session.access_token}`}});
            setIlerleme(res.data.ilerleme||0);
            setTahminiSure(res.data.tahmini_sure);
            setTamamlananSayisi(res.data.tamamlanan||0);
            setToplamSayisi(res.data.toplam||0);
            if(res.data.bulunan!=null) setBulunanSayisi(res.data.bulunan);
            if(!res.data.calisiyor){
                clearInterval(intervalRef.current);clearInterval(gecenRef.current);
                setCalisiyor(false);
                if(res.data.sonuc){
                    setSonuc(res.data.sonuc);
                    setBulunanSayisi(res.data.sonuc.toplam||0);
                    setSecilenler(new Set());
                    const tekHisse=new Set(res.data.sonuc.sonuclar?.map(r=>r["Hisse"])||[]).size;
                    toast.success(`Tarama tamamlandı! ${tekHisse} hisse bulundu.`);
                } else if(res.data.hata){
                    toast.error("Tarama başarısız: "+res.data.hata);
                }
            }
        } catch(e){console.log("Durum hatası:",e);}
    };

    const dogrulukKaydet = async () => {
        if(secilenler.size===0){toast.error("Önce hisse seçin");return;}
        setIslemMenuAcik(false);
        setDogrulukKaydediliyor(true);
        setDogrulukPopup("yukleniyor");
        setDogrulukSonuc(null);
        await new Promise(r=>setTimeout(r,50));
        try {
            const token=await getToken();
            const seciliH=siralanmisVeri.filter(r=>secilenler.has(r["Hisse"]+r["Tip"]));
            const res=await axios.post(`${API_URL}/scan/capa-tarama-analiz/kaydet`,{
                hisseler:   seciliH,
                mod:        piyasa,
                para_birimi:paraBirimi||"USD",
            },{headers:{Authorization:`Bearer ${token}`}});
            setDogrulukSonuc(res.data);
            setDogrulukPopup("tamam");
        } catch(e){
            toast.error("Kaydedilemedi: "+(e.response?.data?.detail||e.message));
            setDogrulukPopup(null);
        } finally{setDogrulukKaydediliyor(false);}
    };

    const alarmAc = () => {
        if(secilenler.size===0){toast.error("Önce hisse seçin");return;}
        const seciliH=siralanmisVeri.filter(r=>secilenler.has(r["Hisse"]+r["Tip"])).map(r=>({hisse:r["Hisse"],fiyat:r["Fiyat"]}));
        setAlarmHisseler(seciliH);setHedefFiyatlar({});
        setAlarmMail(false);setAlarmBildirim(true);
        setAlarmPopup(true);setIslemMenuAcik(false);
    };

    const alarmKaydet = async () => {
        const eksik=alarmHisseler.find(h=>!hedefFiyatlar[h.hisse]||isNaN(parseFloat(hedefFiyatlar[h.hisse])));
        if(eksik){toast.error(`${eksik.hisse} için hedef fiyat girin`);return;}
        setAlarmKaydediliyor(true);
        try {
            const{data:{session}}=await supabase.auth.getSession();
            for(const h of alarmHisseler){
                const fiyat=parseFloat(h.fiyat),hedef=parseFloat(hedefFiyatlar[h.hisse]);
                const pot=fiyat>0?((hedef-fiyat)/fiyat*100).toFixed(2):null;
                const{error}=await supabase.from("alerts").insert({
                    piyasa,sembol:h.hisse,para_birimi:paraBirimi||"USD",fiyat,hedef_fiyat:hedef,
                    potansiyel:pot?parseFloat(pot):null,bildirim_mail:alarmMail,bildirim_popup:alarmBildirim,
                    user_id:session.user.id,
                });
                if(error) throw error;
            }
            toast.success(`${alarmHisseler.length} alarm eklendi!`);
            setAlarmPopup(false);setAlarmHisseler([]);
        } catch(e){toast.error("Alarm kaydedilemedi: "+e.message);}
        finally{setAlarmKaydediliyor(false);}
    };

    const siralamaToggle = kol => {
        if(siralamaKol===kol) setSiralamaYon(y=>y==="asc"?"desc":"asc");
        else{setSiralamaKol(kol);setSiralamaYon("desc");}
    };
    const siralanmisVeri = sonuc?.sonuclar?[...sonuc.sonuclar].sort((a,b)=>{
        if(!siralamaKol) return 0;
        const av=a[siralamaKol],bv=b[siralamaKol];
        if(av==null) return 1;if(bv==null) return -1;
        const cmp=typeof av==="number"?av-bv:String(av).localeCompare(String(bv),"tr");
        return siralamaYon==="asc"?cmp:-cmp;
    }):[];
    // ── Filtreler ──────────────────────────────────────────────────────────
    const [filtreTip,   setFiltreTip]   = useState(new Set());
    const [filtreTemas, setFiltreTemas] = useState(null); // null=hepsi, 1=1+, 3=3+, 5=5+
    const [filtreDurum, setFiltreDurum] = useState(new Set());

    const filtrelenmisVeri = siralanmisVeri.filter(r => {
        if(filtreTip.size>0 && !filtreTip.has(r["Tip"])) return false;
        if(filtreTemas!==null && (r["Temas Sayısı"]||0) < filtreTemas) return false;
        if(filtreDurum.size>0 && !filtreDurum.has(r["Çapa Durum"])) return false;
        return true;
    });
    const toggleFiltreTip   = v => setFiltreTip(p=>{const s=new Set(p);s.has(v)?s.delete(v):s.add(v);return s;});
    const toggleFiltreDurum = v => setFiltreDurum(p=>{const s=new Set(p);s.has(v)?s.delete(v):s.add(v);return s;});
    const filtreAktif = filtreTip.size>0 || filtreTemas!==null || filtreDurum.size>0;

    const tumSecili=filtrelenmisVeri.length>0&&filtrelenmisVeri.every(r=>secilenler.has(r["Hisse"]+r["Tip"]));
    const toggleTum=()=>tumSecili?setSecilenler(new Set()):setSecilenler(new Set(filtrelenmisVeri.map(r=>r["Hisse"]+r["Tip"])));
    const toggleSec=key=>setSecilenler(p=>{const s=new Set(p);s.has(key)?s.delete(key):s.add(key);return s;});

    const gecmisSimAc = () => {
        if(secilenler.size===0){toast.error("Önce hisse seçin");return;}
        setIslemMenuAcik(false);setGecmisPopupAdim("kriter");
    };
    const gecmisSimOnay = () => {
        const hisseler=[...new Set(siralanmisVeri.filter(r=>secilenler.has(r["Hisse"]+r["Tip"])).map(r=>r["Hisse"]))];
        const simParams={
            kaynak:"capa",kaynak_label:"Çapa Noktası Tarama",
            mod:piyasa==="Kripto"?"KRIPTO":"BIST",
            para_birimi:paraBirimi,
            sim_tarihi:gecmisSimTarihi,ref_fiyat:gecmisRefFiyat,
            hisse_listesi:hisseler,oto_baslat:true,
            fvg_tipler:seciliFvgTipler,tolerans:tolerans/100,
        };
        setGecmisPopupAdim(null);
        navigate("/gecmis-simulasyon",{state:simParams});
    };

    const kolonlar = ["Hisse","Tip","Fiyat","Alt Sınır","Üst Sınır","Temas Sayısı","Çapa Durum"];

    return (
        <div style={{padding:24,background:C.bg,minHeight:"100vh",color:C.text,fontFamily:"system-ui,sans-serif"}}>

            {/* Başlık */}
            <div style={{display:"flex",alignItems:"center",gap:14,marginBottom:24}}>
                <span style={{fontSize:32}}>⚓</span>
                <div>
                    <h1 style={{margin:0,fontSize:22,fontWeight:800,color:C.text}}>Çapa Noktası Tarama</h1>
                    <p style={{margin:0,fontSize:13,color:C.muted}}>Yıllık FVG bazlı çapa noktalarını tespit et</p>
                </div>
            </div>

            {/* Kontrol Paneli */}
            <div style={{background:C.panel,border:`1px solid ${C.border}`,borderRadius:12,
                padding:"16px 20px",marginBottom:20,display:"flex",gap:12,flexWrap:"wrap",alignItems:"flex-end",
                opacity:calisiyor?0.5:1,pointerEvents:calisiyor?"none":"auto",transition:"opacity 0.3s"}}>

                {/* Piyasa */}
                <fieldset style={{border:`1px solid ${C.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}>
                    <legend style={{fontSize:11,color:C.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em"}}>PİYASA</legend>
                    <div style={{display:"flex",gap:6}}>
                        {piyasaSecenekleri.map(p=>(
                            <button key={p} onClick={()=>setPiyasa(p)} style={{
                                padding:"5px 14px",borderRadius:6,fontWeight:600,fontSize:13,cursor:"pointer",
                                border:`2px solid ${piyasa===p?C.accent:C.border}`,
                                background:piyasa===p?C.accent+"22":"transparent",
                                color:piyasa===p?C.accent:C.muted}}>{p}</button>
                        ))}
                    </div>
                </fieldset>

                {/* Para Birimi */}
                <fieldset style={{border:`1px solid ${C.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}>
                    <legend style={{fontSize:11,color:C.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em"}}>PARA BİRİMİ</legend>
                    <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                        {paraBirimiSecenekleri.map(p=>(
                            <button key={p} onClick={()=>setParaBirimi(p)} style={{
                                padding:"5px 12px",borderRadius:6,fontWeight:600,fontSize:12,cursor:"pointer",
                                border:`2px solid ${paraBirimi===p?"#a78bfa":C.border}`,
                                background:paraBirimi===p?"#a78bfa22":"transparent",
                                color:paraBirimi===p?"#a78bfa":C.muted}}>{p}</button>
                        ))}
                    </div>
                </fieldset>

                {/* FVG Tipi */}
                <fieldset style={{border:`1px solid ${C.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}>
                    <legend style={{fontSize:11,color:C.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em"}}>FVG TİPİ</legend>
                    <div style={{display:"flex",gap:10}}>
                        {Object.keys(fvgTipler).map(tip=>(
                            <label key={tip} style={{display:"flex",alignItems:"center",gap:6,cursor:"pointer",
                                fontSize:13,userSelect:"none",color:fvgTipler[tip]?tipRenk(tip):C.muted,
                                fontWeight:fvgTipler[tip]?600:400}}>
                                <input type="checkbox" checked={fvgTipler[tip]} onChange={()=>toggleFvgTip(tip)}
                                    style={{width:15,height:15,cursor:"pointer",accentColor:tipRenk(tip)}}/>
                                {tip}
                            </label>
                        ))}
                    </div>
                </fieldset>

                {/* Tolerans */}
                <fieldset style={{border:`1px solid ${C.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}>
                    <legend style={{fontSize:11,color:C.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em",display:"flex",alignItems:"center",gap:4}}>TOLERANS <BilgiIkonu alan="TOLERANS"/></legend>
                    <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                        {[30,50,70,80,90,100].map(v=>(
                            <button key={v} onClick={()=>setTolerans(v)} style={{
                                padding:"5px 10px",borderRadius:6,fontWeight:600,fontSize:12,cursor:"pointer",
                                border:`2px solid ${tolerans===v?C.gold:C.border}`,
                                background:tolerans===v?C.gold+"22":"transparent",
                                color:tolerans===v?C.gold:C.muted}}>%{v}</button>
                        ))}
                    </div>
                </fieldset>

                {/* Tara */}
                <button onClick={taramaBaslat} style={{
                    padding:"10px 28px",borderRadius:8,fontWeight:700,fontSize:14,cursor:"pointer",
                    background:"linear-gradient(135deg,#4c1d95,#7c3aed)",
                    border:"none",color:"white",alignSelf:"flex-end"}}>
                    🔍 Tara
                </button>
            </div>

            {/* Uyarı + İlerleme */}
            {calisiyor&&(
                <>
                    <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:10,
                        padding:"10px 16px",borderRadius:8,background:"#422006",border:"1px solid #92400e"}}>
                        <span style={{fontSize:16}}>⚠️</span>
                        <span style={{fontSize:13,color:"#fde68a",fontWeight:600}}>
                            Tarama tamamlanıncaya kadar sayfayı kapatmayın
                        </span>
                    </div>
                    <TaramaIlerlemePaneli
                        ilerleme={ilerleme} tamamlanan={tamamlananSayisi}
                        toplam={toplamSayisi} bulunan={bulunanSayisi}
                        gecen={gecenSure} tahminiSure={tahminiSure}/>
                </>
            )}

            {/* Sonuç Özeti */}
            {sonuc&&(
                <div style={{background:C.panel,border:`1px solid ${C.border}`,borderRadius:12,
                    padding:"12px 20px",marginBottom:16,display:"flex",alignItems:"center",gap:16,flexWrap:"wrap"}}>

                    {/* İşlemler — sol */}
                    <div style={{position:"relative"}}>
                        <button onClick={()=>setIslemMenuAcik(v=>!v)} style={{
                            padding:"6px 16px",borderRadius:8,border:`1px solid ${C.border}`,
                            background:C.panel,cursor:"pointer",fontSize:13,fontWeight:500,
                            color:C.text,display:"flex",alignItems:"center",gap:5}}>
                            İşlemler ▾
                        </button>
                        {islemMenuAcik&&(
                            <div style={{position:"absolute",top:"calc(100% + 4px)",left:0,
                                background:C.panel,border:`1px solid ${C.border}`,
                                borderRadius:10,boxShadow:"0 8px 24px rgba(0,0,0,0.4)",
                                zIndex:100,minWidth:300,overflow:"visible"}}>
                                {[
                                    {label:dogrulukKaydediliyor?"⏳ Kaydediliyor...":"✅ Doğruluk Analizine Gönder",aktif:!dogrulukKaydediliyor,onClick:dogrulukKaydet},
                                    {label:"🔮 Geçmiş Simülasyonuna Gönder",aktif:true,onClick:gecmisSimAc},
                                    {label:"🔗 Çoklu Taramaya Gönder",aktif:true,onClick:()=>{
                                        if(secilenler.size===0){toast.error("Önce hisse seçin");return;}
                                        setCokluSecModul(null);setCokluFiltre(null);setCokluPeriyotlar([]);
                                        setCokluPopup(true);setIslemMenuAcik(false);
                                    }},
                                    {label:"🏆 Puanlamaya Gönder",aktif:true,onClick:()=>{
                                        if(secilenler.size===0){toast.error("Önce hisse seçin");return;}
                                        const bistOpts=["Gün İçi","Kısa Vade (1-10 gün)","Orta Vade (11-60 gün)","Uzun Vade (61+ gün)"];
                                        setPuanlamaVade(piyasa==="Kripto"?"Kaldıraçlı İşlem":bistOpts[0]);
                                        setPuanlamaYon(new Set(["Long","Short"]));setPuanlamaMinPuan(0);
                                        setPuanlamaPopupAdim("kriter");setIslemMenuAcik(false);
                                    }},
                                    {label:"⏰ Alarm Ekle",aktif:true,onClick:alarmAc},
                                    {label:"🔎 İzleme Listesine Ekle",aktif:false,onClick:()=>{}},
                                ].map(item=>(
                                    <button key={item.label} onClick={item.aktif?item.onClick:undefined}
                                        disabled={!item.aktif}
                                        style={{display:"block",width:"100%",textAlign:"left",
                                            padding:"10px 16px",border:"none",background:"none",
                                            cursor:item.aktif?"pointer":"default",
                                            color:item.aktif?C.text:C.muted,fontSize:13,
                                            borderBottom:`1px solid ${C.border}`}}>
                                        {item.label}
                                    </button>
                                ))}
                                <IndirMenusu sonuc={sonuc} siralanmisVeri={siralanmisVeri} setIslemMenuAcik={setIslemMenuAcik}/>
                            </div>
                        )}
                    </div>

                    <div style={{width:1,height:20,background:C.border}}/>
                    <span style={{fontSize:13,color:C.muted}}>📊 <strong style={{color:C.text}}>{seciliFvgTipler.join(", ")}</strong></span>
                    {sonuc.para_birimi&&<span style={{fontSize:13,color:C.muted}}>💱 <strong style={{color:C.text}}>{sonuc.para_birimi}</strong></span>}
                    <span style={{fontSize:13,color:C.muted}}>🎯 Tolerans: <strong style={{color:C.text}}>%{Math.round((sonuc.tolerans??tolerans/100)*100)}</strong></span>
                    {(() => {
                        const tekHisse=new Set(sonuc.sonuclar?.map(r=>r["Hisse"])||[]).size;
                        return <span style={{fontSize:13}}>✨ <strong style={{color:C.bullish}}>{tekHisse}</strong><span style={{color:C.muted}}> hisse bulundu</span></span>;
                    })()}
                    <span style={{fontSize:11,color:C.muted,marginLeft:"auto"}}>
                        {new Date(sonuc.tarih).toLocaleString("tr-TR")}
                    </span>
                </div>
            )}

            {/* Filtre Kartı */}
            {siralanmisVeri.length>0&&(
                <div style={{background:C.panel,border:`1px solid ${C.border}`,borderRadius:12,
                    padding:"12px 20px",marginBottom:12,display:"flex",gap:20,flexWrap:"wrap",alignItems:"center"}}>

                    {/* FVG Tipi */}
                    <div style={{display:"flex",alignItems:"center",gap:8}}>
                        <span style={{fontSize:11,fontWeight:700,color:C.muted,letterSpacing:"0.05em",whiteSpace:"nowrap"}}>FVG TİPİ</span>
                        {["Boğa FVG","Ayı FVG"].map(tip=>{
                            const aktif=filtreTip.has(tip);
                            const renk=tipRenk(tip);
                            return(
                                <button key={tip} onClick={()=>toggleFiltreTip(tip)} style={{
                                    padding:"4px 12px",borderRadius:20,fontSize:12,cursor:"pointer",
                                    fontWeight:aktif?700:400,
                                    border:`2px solid ${aktif?renk:C.border}`,
                                    background:aktif?renk+"22":"transparent",
                                    color:aktif?renk:C.muted}}>{tip}</button>
                            );
                        })}
                    </div>

                    <div style={{width:1,height:20,background:C.border}}/>

                    {/* Temas Sayısı */}
                    <div style={{display:"flex",alignItems:"center",gap:8}}>
                        <span style={{fontSize:11,fontWeight:700,color:C.muted,letterSpacing:"0.05em",whiteSpace:"nowrap"}}>TEMAS SAYISI</span>
                        {[{label:"Tümü",val:null},{label:"1+",val:1},{label:"3+",val:3},{label:"5+",val:5}].map(opt=>{
                            const aktif=filtreTemas===opt.val;
                            return(
                                <button key={String(opt.val)} onClick={()=>setFiltreTemas(opt.val)} style={{
                                    padding:"4px 12px",borderRadius:20,fontSize:12,cursor:"pointer",
                                    fontWeight:aktif?700:400,
                                    border:`2px solid ${aktif?C.accent:C.border}`,
                                    background:aktif?C.accent+"22":"transparent",
                                    color:aktif?C.accent:C.muted}}>{opt.label}</button>
                            );
                        })}
                    </div>

                    <div style={{width:1,height:20,background:C.border}}/>

                    {/* Çapa Durum */}
                    <div style={{display:"flex",alignItems:"center",gap:8}}>
                        <span style={{fontSize:11,fontWeight:700,color:C.muted,letterSpacing:"0.05em",whiteSpace:"nowrap"}}>ÇAPA DURUM</span>
                        {[{label:"🎯 Temas aşıldı",renk:C.bullish},{label:"👀 İzleniyor",renk:C.warning}].map(opt=>{
                            const aktif=filtreDurum.has(opt.label);
                            return(
                                <button key={opt.label} onClick={()=>toggleFiltreDurum(opt.label)} style={{
                                    padding:"4px 12px",borderRadius:20,fontSize:12,cursor:"pointer",
                                    fontWeight:aktif?700:400,
                                    border:`2px solid ${aktif?opt.renk:C.border}`,
                                    background:aktif?opt.renk+"22":"transparent",
                                    color:aktif?opt.renk:C.muted}}>{opt.label}</button>
                            );
                        })}
                    </div>

                    {/* Özet + Temizle */}
                    <div style={{marginLeft:"auto",display:"flex",alignItems:"center",gap:10}}>
                        <span style={{fontSize:12,color:C.muted}}>
                            <strong style={{color:C.text}}>{filtrelenmisVeri.length}</strong>{" / "}{siralanmisVeri.length} sonuç
                        </span>
                        {filtreAktif&&(
                            <button onClick={()=>{setFiltreTip(new Set());setFiltreTemas(null);setFiltreDurum(new Set());}}
                                style={{padding:"4px 12px",borderRadius:20,fontSize:12,cursor:"pointer",
                                    border:`1px solid ${C.bearish}66`,background:C.bearish+"11",color:C.bearish}}>
                                ✕ Temizle
                            </button>
                        )}
                    </div>
                </div>
            )}

            {/* Tablo */}
            {filtrelenmisVeri.length>0&&(
                <div style={{overflowX:"auto",background:C.panel,border:`1px solid ${C.border}`,borderRadius:12}}>
                    <table style={{width:"100%",borderCollapse:"collapse",fontSize:13}}>
                        <thead>
                            <tr style={{borderBottom:`1px solid ${C.border}`,background:C.bg}}>
                                <th style={{padding:"10px 12px",width:36,textAlign:"center"}}>
                                    <input type="checkbox" checked={tumSecili} onChange={toggleTum}
                                        style={{cursor:"pointer",width:15,height:15}}/>
                                </th>
                                {kolonlar.map(h=>{
                                    const baslik = h === "Fiyat"
                                        ? (sonuc?.para_birimi === "USD (Futures)" ? "Fiyat (USD-F)"
                                         : sonuc?.para_birimi ? `Fiyat (${sonuc.para_birimi})`
                                         : "Fiyat (USD)")
                                        : h;
                                    return (
                                    <th key={h} onClick={()=>siralamaToggle(h)}
                                        style={{padding:"10px 12px",textAlign:"left",cursor:"pointer",
                                            userSelect:"none",color:C.muted,fontSize:11,
                                            fontWeight:700,letterSpacing:"0.03em",whiteSpace:"nowrap"}}>
                                        <span>{baslik}</span>
                                        {BILGI_ICERIK[h]&&<BilgiIkonu alan={h}/>}
                                        {" "}{siralamaKol===h?(siralamaYon==="asc"?"↑":"↓"):""}
                                    </th>
                                    );
                                })}
                            </tr>
                        </thead>
                        <tbody>
                            {filtrelenmisVeri.map((r,i)=>(
                                <tr key={i} style={{
                                    background:secilenler.has(r["Hisse"]+r["Tip"])?C.accent+"18":i%2===0?C.panel:C.bg,
                                    borderBottom:`1px solid ${C.border}22`}}>
                                    <td style={{padding:"8px 12px",textAlign:"center"}} onClick={e=>e.stopPropagation()}>
                                        <input type="checkbox" checked={secilenler.has(r["Hisse"]+r["Tip"])}
                                            onChange={()=>toggleSec(r["Hisse"]+r["Tip"])}
                                            style={{cursor:"pointer",width:15,height:15}}/>
                                    </td>
                                    <td style={{padding:"8px 12px",fontWeight:700,color:C.accent}}>{r["Hisse"]}</td>
                                    <td style={{padding:"8px 12px",color:tipRenk(r["Tip"]),fontWeight:600}}>{r["Tip"]}</td>
                                    <td style={{padding:"8px 12px",color:C.text}}>{r["Fiyat"]}</td>
                                    <td style={{padding:"8px 12px",color:C.text}}>{r["Alt Sınır"]}</td>
                                    <td style={{padding:"8px 12px",color:C.text}}>{r["Üst Sınır"]}</td>
                                    <td style={{padding:"8px 12px",color:C.accent,fontWeight:700}}>{r["Temas Sayısı"]}</td>
                                    <td style={{padding:"8px 12px",fontWeight:600,
                                        color:r["Çapa Durum"]?.includes("aşıldı")?C.bullish:C.warning}}>
                                        {r["Çapa Durum"]}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            {sonuc?.sonuclar?.length===0&&(
                <div style={{textAlign:"center",padding:"3rem",color:C.muted}}>
                    ⚓ Seçilen kriterlere uygun çapa noktası bulunamadı.
                </div>
            )}

            {/* Doğruluk Popup */}
            {dogrulukPopup&&(
                <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.7)",
                    display:"flex",alignItems:"center",justifyContent:"center",zIndex:2000}}>
                    <div style={{background:C.panel,border:`1px solid ${C.border}`,borderRadius:14,
                        padding:"2rem",width:420,maxWidth:"95vw",boxShadow:"0 12px 48px rgba(0,0,0,0.5)"}}>
                        {dogrulukPopup==="yukleniyor"?(
                            <>
                                <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:20}}>
                                    <span style={{fontSize:24}}>✅</span>
                                    <div>
                                        <div style={{fontSize:16,fontWeight:700,color:C.text}}>Doğruluk Analizi</div>
                                        <div style={{fontSize:12,color:C.muted,marginTop:2}}>Veriler kaydediliyor...</div>
                                    </div>
                                </div>
                                <HareketliBar/>
                                <div style={{fontSize:13,color:C.muted,textAlign:"center"}}>Kaydediliyor...</div>
                            </>
                        ):(
                            <>
                                <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:20}}>
                                    <span style={{fontSize:28}}>✅</span>
                                    <div style={{fontSize:16,fontWeight:700,color:C.text}}>Kayıt Tamamlandı</div>
                                </div>
                                <div style={{background:C.bullish+"22",border:`1px solid ${C.bullish}44`,
                                    borderRadius:8,padding:"14px 16px",marginBottom:20,fontSize:14,color:C.bullish,lineHeight:1.6}}>
                                    Seçilen hisseler <strong>"Doğruluk Analizi"</strong> veri tabanına kaydedildi.
                                    {dogrulukSonuc&&(
                                        <div style={{marginTop:8,fontSize:12,color:C.muted}}>
                                            {dogrulukSonuc.toplam?<span>✔ {dogrulukSonuc.toplam} kayıt işleme alındı</span>
                                                :dogrulukSonuc.eklenen!=null&&<span>✔ {dogrulukSonuc.eklenen} yeni · {dogrulukSonuc.atlanan} mevcut</span>}
                                        </div>
                                    )}
                                </div>
                                <div style={{display:"flex",justifyContent:"flex-end"}}>
                                    <button onClick={()=>{setDogrulukPopup(null);setDogrulukSonuc(null);}}
                                        style={{padding:"8px 28px",borderRadius:8,border:"none",
                                            background:"linear-gradient(135deg,#1d4ed8,#3b82f6)",
                                            color:"white",cursor:"pointer",fontSize:14,fontWeight:600}}>
                                        Tamam
                                    </button>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            )}

            {/* Puanlama Kriter */}
            {puanlamaPopupAdim==="kriter"&&(()=>{
                const bistOpts=["Gün İçi","Kısa Vade (1-10 gün)","Orta Vade (11-60 gün)","Uzun Vade (61+ gün)"];
                const kriptoOpts=["Kaldıraçlı İşlem","Gün İçi","Kısa Vade (1-10 gün)","Orta Vade (11-60 gün)","Uzun Vade (61+ gün)"];
                const vadeOpts=piyasa==="Kripto"?kriptoOpts:bistOpts;
                const kaldırac=puanlamaVade==="Kaldıraçlı İşlem";
                const paraB=paraBirimi;
                const minPuanOpts=[0,25,50,60,75];
                const toggleYon=y=>setPuanlamaYon(prev=>{const n=new Set(prev);if(n.has(y)){if(n.size===1)return prev;n.delete(y);}else n.add(y);return n;});
                return(
                    <div style={popupStyles.overlay}>
                        <div style={{...popupStyles.modal,width:"420px"}}>
                            <div style={popupStyles.baslik}>🏆 Puanlamaya Gönder</div>
                            <p style={{fontSize:"13px",color:"#94a3b8",marginBottom:"1.25rem"}}>
                                <strong>{secilenler.size}</strong> hisse seçildi. Puanlama kriterlerini belirleyin.
                            </p>
                            <div style={{display:"flex",gap:"8px",marginBottom:"1.25rem"}}>
                                {[["Piyasa",piyasa],["Para Birimi",paraB]].map(([et,d])=>(
                                    <div key={et} style={{flex:1,background:"#0f172a",border:"1px solid #334155",borderRadius:"8px",padding:"10px 14px"}}>
                                        <div style={{fontSize:"11px",color:"#64748b",fontWeight:"500",marginBottom:"2px"}}>{et} (kilitli)</div>
                                        <div style={{fontSize:"14px",fontWeight:"600",color:"#e2e8f0"}}>🔒 {d}</div>
                                    </div>
                                ))}
                            </div>
                            <div style={{marginBottom:"1.25rem"}}>
                                <label style={{fontSize:"12px",fontWeight:"600",color:"#93c5fd",display:"block",marginBottom:"6px"}}>📅 Vade</label>
                                <select value={puanlamaVade||""} onChange={e=>setPuanlamaVade(e.target.value)}
                                    style={{width:"100%",padding:"9px 12px",borderRadius:"8px",border:"1px solid #334155",fontSize:"13px",background:"#0f172a",color:"#e2e8f0",cursor:"pointer"}}>
                                    {vadeOpts.map(o=><option key={o} value={o}>{o}</option>)}
                                </select>
                            </div>
                            {kaldırac&&(
                                <div style={{marginBottom:"1.25rem"}}>
                                    <div style={{fontSize:"12px",fontWeight:"600",color:"#93c5fd",marginBottom:"8px"}}>📈 İşlem Yönü</div>
                                    <div style={{display:"flex",gap:"8px"}}>
                                        {["Long","Short"].map(y=>(
                                            <button key={y} type="button" onClick={()=>toggleYon(y)}
                                                style={{flex:1,padding:"10px",borderRadius:"8px",cursor:"pointer",fontSize:"13px",fontWeight:"600",
                                                    border:puanlamaYon.has(y)?"2px solid #3b82f6":"2px solid #334155",
                                                    background:puanlamaYon.has(y)?(y==="Long"?"#052e16":"#450a0a"):"transparent",
                                                    color:puanlamaYon.has(y)?(y==="Long"?"#4ade80":"#f87171"):"#64748b"}}>
                                                {y==="Long"?"📈 Long":"📉 Short"}
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            )}
                            <div style={{marginBottom:"1.5rem"}}>
                                <label style={{fontSize:"12px",fontWeight:"600",color:"#93c5fd",display:"block",marginBottom:"8px"}}>🎯 Minimum Puan</label>
                                <div style={{display:"flex",gap:"6px"}}>
                                    {minPuanOpts.map(p=>(
                                        <button key={p} type="button" onClick={()=>setPuanlamaMinPuan(p)}
                                            style={{flex:1,padding:"8px 4px",borderRadius:"8px",cursor:"pointer",fontSize:"13px",
                                                fontWeight:puanlamaMinPuan===p?"700":"400",
                                                border:puanlamaMinPuan===p?"2px solid #3b82f6":"2px solid #334155",
                                                background:puanlamaMinPuan===p?"#2563eb":"transparent",
                                                color:puanlamaMinPuan===p?"white":"#e2e8f0"}}>
                                            {p===0?"0+":`${p}+`}
                                        </button>
                                    ))}
                                </div>
                            </div>
                            <div style={{display:"flex",gap:"8px",justifyContent:"flex-end"}}>
                                <button onClick={()=>setPuanlamaPopupAdim(null)} style={popupStyles.btnVazgec}>İptal</button>
                                <button onClick={()=>setPuanlamaPopupAdim("onay")} style={popupStyles.btnPrimary}>Devam Et →</button>
                            </div>
                        </div>
                    </div>
                );
            })()}

            {/* Puanlama Onay */}
            {puanlamaPopupAdim==="onay"&&(
                <div style={popupStyles.overlay}>
                    <div style={{...popupStyles.modal,width:"440px"}}>
                        <div style={popupStyles.baslik}>⚠️ Sayfadan Ayrılıyorsunuz</div>
                        <div style={{background:"#422006",border:"1px solid #92400e",borderRadius:"8px",padding:"1rem",marginBottom:"1.25rem",fontSize:"13px",color:"#fde68a",lineHeight:"1.7"}}>
                            Başka bir sayfaya yönlendiriliyorsunuz. <strong>Ekrandaki tarama sonuçları kaybolacak.</strong>
                            <br/><br/>Seçili <strong>{secilenler.size} hisse</strong> için <strong>Puanlama ve Tahmin</strong> taraması otomatik olarak başlatılacaktır. Emin misiniz?
                        </div>
                        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"8px",marginBottom:"1.25rem",fontSize:"12px"}}>
                            {[["Piyasa",piyasa],["Para Birimi",paraBirimi],["Vade",puanlamaVade],
                              ...(puanlamaVade==="Kaldıraçlı İşlem"?[["İşlem Yönü",[...puanlamaYon].join(" & ")]]:[] ),
                              ["Min Puan",puanlamaMinPuan===0?"0+ (Tümü)":`${puanlamaMinPuan}+`],["Hisse Sayısı",`${secilenler.size} hisse`],
                            ].map(([k,v])=>(
                                <div key={k} style={{display:"flex",justifyContent:"space-between",background:"#0f172a",borderRadius:"6px",padding:"6px 10px"}}>
                                    <span style={{color:"#94a3b8"}}>{k}:</span>
                                    <strong style={{color:"#e2e8f0"}}>{v}</strong>
                                </div>
                            ))}
                        </div>
                        <div style={{display:"flex",gap:"8px",justifyContent:"flex-end"}}>
                            <button onClick={()=>setPuanlamaPopupAdim("kriter")} style={popupStyles.btnVazgec}>← Geri</button>
                            <button onClick={()=>setPuanlamaPopupAdim(null)} style={popupStyles.btnVazgec}>Hayır, İptal</button>
                            <button onClick={()=>{
                                const hisseListesi=[...new Set(siralanmisVeri.filter(r=>secilenler.has(r["Hisse"]+r["Tip"])).map(r=>r["Hisse"]))];
                                setPuanlamaPopupAdim(null);
                                navigate("/puanlama-tahmin",{state:{kaynak:"capa_tarama",piyasa,para_birimi:paraBirimi,vade:puanlamaVade,islem_yonu:[...puanlamaYon].join(","),min_puan:puanlamaMinPuan,hisse_listesi:hisseListesi,oto_baslat:true}});
                            }} style={popupStyles.btnPrimary}>Evet, Başlat 🚀</button>
                        </div>
                    </div>
                </div>
            )}

            {/* Geçmiş Sim Kriter */}
            {gecmisPopupAdim==="kriter"&&(
                <div style={popupStyles.overlay}>
                    <div style={{...popupStyles.modal,width:"420px"}}>
                        <div style={popupStyles.baslik}>🔮 Geçmiş Simülasyonu</div>
                        <p style={{fontSize:"13px",color:"#94a3b8",marginBottom:"1.25rem"}}>
                            <strong>{new Set(siralanmisVeri.filter(r=>secilenler.has(r["Hisse"]+r["Tip"])).map(r=>r["Hisse"])).size}</strong> hisse seçildi.
                        </p>
                        <div style={{display:"flex",flexDirection:"column",gap:"1rem",marginBottom:"1.25rem"}}>
                            <div>
                                <label style={{fontSize:"12px",fontWeight:"600",color:"#93c5fd",display:"block",marginBottom:"6px"}}>📅 Simülasyon Tarihi</label>
                                <MiniTakvim value={gecmisSimTarihi} onChange={setGecmisSimTarihi}/>
                            </div>
                            <div>
                                <label style={{fontSize:"12px",fontWeight:"600",color:"#93c5fd",display:"block",marginBottom:"6px"}}>💱 Referans Fiyat</label>
                                <div style={{display:"flex",gap:"8px"}}>
                                    {["Bugünkü","En Yüksek"].map(opt=>(
                                        <button key={opt} type="button" onClick={()=>setGecmisRefFiyat(opt)}
                                            style={{flex:1,padding:"10px",borderRadius:"8px",cursor:"pointer",fontSize:"13px",fontWeight:"500",
                                                border:gecmisRefFiyat===opt?"2px solid #7c3aed":"2px solid #334155",
                                                background:gecmisRefFiyat===opt?"#7c3aed":"transparent",
                                                color:gecmisRefFiyat===opt?"white":"#e2e8f0"}}>
                                            {opt==="Bugünkü"?"📅 Bugünkü Fiyat":"🏆 En Yüksek Fiyat"}
                                        </button>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div style={{display:"flex",gap:"8px",justifyContent:"flex-end"}}>
                            <button onClick={()=>setGecmisPopupAdim(null)} style={popupStyles.btnVazgec}>İptal</button>
                            <button onClick={()=>{if(!gecmisSimTarihi)return;setGecmisPopupAdim("onay");}} style={popupStyles.btnPrimary}>Devam Et →</button>
                        </div>
                    </div>
                </div>
            )}

            {/* Geçmiş Sim Onay */}
            {gecmisPopupAdim==="onay"&&(
                <div style={popupStyles.overlay}>
                    <div style={popupStyles.modal}>
                        <div style={popupStyles.baslik}>⚠️ Sayfadan Ayrılıyorsunuz</div>
                        <div style={{background:"#422006",border:"1px solid #92400e",borderRadius:"8px",padding:"1rem",marginBottom:"1.25rem",fontSize:"13px",color:"#fde68a",lineHeight:"1.7"}}>
                            Bu sayfa temizlenerek <strong>Geçmiş Simülasyon</strong> sayfasına yönlendirileceksiniz.
                            Seçili hisseler için{" "}<strong>{(()=>{const d=new Date(gecmisSimTarihi+"T00:00:00");return d.toLocaleDateString("tr-TR",{day:"2-digit",month:"long",year:"numeric"});})()}</strong>{" "}tarihi simülasyonu otomatik başlatılacaktır.
                            <br/><br/>Devam etmek istiyor musunuz?
                        </div>
                        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"8px",marginBottom:"1.25rem",fontSize:"12px"}}>
                            {[["Piyasa",piyasa],["Para Birimi",paraBirimi],
                              ["FVG Tipi",seciliFvgTipler.join(", ")],["Tolerans",`%${tolerans}`],
                              ["Referans Fiyat",gecmisRefFiyat],
                              ["Simülasyon Tarihi",(()=>{const d=new Date(gecmisSimTarihi+"T00:00:00");return d.toLocaleDateString("tr-TR",{day:"2-digit",month:"long",year:"numeric"});})()],
                              ["Hisse Sayısı",`${new Set(siralanmisVeri.filter(r=>secilenler.has(r["Hisse"]+r["Tip"])).map(r=>r["Hisse"])).size} hisse`],
                            ].map(([k,v])=>(
                                <div key={k} style={{display:"flex",justifyContent:"space-between",background:"#0f172a",borderRadius:"6px",padding:"6px 10px"}}>
                                    <span style={{color:"#94a3b8"}}>{k}:</span>
                                    <strong style={{color:"#e2e8f0"}}>{v}</strong>
                                </div>
                            ))}
                        </div>
                        <div style={{display:"flex",gap:"8px",justifyContent:"flex-end"}}>
                            <button onClick={()=>setGecmisPopupAdim("kriter")} style={popupStyles.btnVazgec}>← Geri</button>
                            <button onClick={()=>setGecmisPopupAdim(null)} style={popupStyles.btnVazgec}>Hayır, İptal</button>
                            <button onClick={gecmisSimOnay} style={popupStyles.btnPrimary}>Evet, Başlat 🚀</button>
                        </div>
                    </div>
                </div>
            )}

            {/* Çoklu Taramaya Gönder */}
            {cokluPopup&&(
                <CokluTaramaGonderPopup
                    piyasa={piyasa}
                    paraBirimi={paraBirimi}
                    secilenSayisi={new Set(siralanmisVeri.filter(r=>secilenler.has(r["Hisse"]+r["Tip"])).map(r=>r["Hisse"])).size}
                    secilenModul={cokluSecModul}
                    filtre={cokluFiltre}
                    periyotlar={cokluPeriyotlar}
                    onModulSec={m=>{
                        setCokluSecModul(m);setCokluFiltre(defaultCokluFiltreler(m,piyasa));
                        const MAP={"Dip Tarama":"dip_tarama","Likidite Tarama":"likidite_tarama","FVG Tarama":"fvg_tarama","Çapa Noktası Tarama":"capa_noktasi_tarama","MSB Tarama":"msb_tarama","OTE Tarama":"ote_tarama","OB & BB Tarama":"obbb_tarama","IDM Tarama":"idm_tarama","P/D Zone Tarama":"pd_zone_tarama","SMT Tarama":"smt_tarama","Killzone Tarama":"killzone_tarama","Topdown Cascade":"topdown_cascade_tarama","Hacim Profili Tarama":"hacim_profili_tarama","Hacim Akışı Tarama":"hacim_akisi_tarama","Divergence Tarama":"divergence_tarama"};
                        const dbKey=MAP[m];
                        if(dbKey) getLookupPeriyotlar(dbKey).then(list=>setCokluPeriyotlar(list)).catch(()=>setCokluPeriyotlar([]));
                        else setCokluPeriyotlar([]);
                    }}
                    onFiltreDegis={setCokluFiltre}
                    onIptal={()=>{setCokluPopup(false);setCokluSecModul(null);setCokluFiltre(null);}}
                    onBaslat={()=>{if(!cokluSecModul||!cokluFiltre){toast.error("Modül seçin");return;}setCokluPopup(false);setCokluOnayPopup(true);}}/>
            )}

            {/* Çoklu Onay */}
            {cokluOnayPopup&&(
                <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.55)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:1000}}>
                    <div style={{background:"#1e293b",border:"1px solid #334155",borderRadius:"14px",padding:"1.75rem",width:"420px",maxWidth:"95vw",boxShadow:"0 12px 48px rgba(0,0,0,0.5)",color:"#e2e8f0"}}>
                        <div style={{fontSize:"17px",fontWeight:"700",color:"#e2e8f0",marginBottom:"0.75rem"}}>⚠️ Sayfadan Ayrılıyorsunuz</div>
                        <div style={{background:"#422006",border:"1px solid #92400e",borderRadius:"8px",padding:"1rem",marginBottom:"1.25rem",fontSize:"13px",color:"#fde68a",lineHeight:"1.7"}}>
                            Başka bir sayfaya yönlendiriliyorsunuz. <strong>Bu sayfadaki tarama sonuçları kaybolacak.</strong>
                            <br/><br/>Devam etmek istiyor musunuz?
                        </div>
                        <div style={{display:"flex",gap:"8px",justifyContent:"flex-end"}}>
                            <button onClick={()=>{setCokluOnayPopup(false);setCokluPopup(true);}}
                                style={{padding:"8px 18px",borderRadius:"8px",border:"1px solid #334155",background:"transparent",cursor:"pointer",fontSize:"13px",color:"#94a3b8"}}>
                                ← Geri Dön
                            </button>
                            <button onClick={()=>{
                                const hisseListesi=[...new Set(siralanmisVeri.filter(r=>secilenler.has(r["Hisse"]+r["Tip"])).map(r=>r["Hisse"]))];
                                setCokluOnayPopup(false);
                                navigate("/coklu-tarama",{state:{kaynak:"capa_tarama",piyasa,paraBirimi:paraBirimi,kaynakModul:"Çapa Noktası Tarama",kaynakFiltre:{ fvg_tipler: fvgTipler, tolerans },kaynakSonucHisseler:hisseListesi,modul:cokluSecModul,filtre:cokluFiltre,hisseListesi,oto_baslat:true}});
                            }}
                                style={{padding:"8px 20px",borderRadius:"8px",border:"none",background:"linear-gradient(135deg,#1d4ed8,#3b82f6)",color:"white",cursor:"pointer",fontSize:"13px",fontWeight:"600"}}>
                                Evet, Devam Et →
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Alarm Popup */}
            {alarmPopup&&(
                <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.5)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:1000}}>
                    <div style={{background:"#1e293b",border:"1px solid #334155",borderRadius:"12px",padding:"1.5rem",width:"420px",maxHeight:"80vh",overflowY:"auto",boxShadow:"0 8px 32px rgba(0,0,0,0.5)"}}>
                        <h3 style={{margin:"0 0 0.75rem",fontSize:"16px",color:"#e2e8f0"}}>⏰ Alarm Ekle</h3>
                        <div style={{display:"flex",flexDirection:"column",gap:10}}>
                            {alarmHisseler.map(h=>{
                                const hedef=hedefFiyatlar[h.hisse]||"",fiyat=parseFloat(h.fiyat),hedefN=parseFloat(hedef);
                                const pct=hedef&&!isNaN(hedefN)&&fiyat>0?((hedefN-fiyat)/fiyat*100).toFixed(2):null;
                                return(
                                    <div key={h.hisse} style={{background:"#0f172a",borderRadius:8,padding:"10px 12px",border:"1px solid #334155"}}>
                                        <div style={{display:"flex",justifyContent:"space-between",marginBottom:8}}>
                                            <strong style={{fontSize:14,color:"#e2e8f0"}}>{h.hisse}</strong>
                                            <span style={{color:"#94a3b8",fontSize:12}}>Güncel: {h.fiyat}</span>
                                        </div>
                                        <div style={{display:"flex",alignItems:"center",gap:8}}>
                                            <span style={{color:"#94a3b8",fontSize:12,minWidth:80}}>Hedef Fiyat:</span>
                                            <input type="number" value={hedef}
                                                onChange={e=>setHedefFiyatlar(p=>({...p,[h.hisse]:e.target.value}))}
                                                style={{flex:1,padding:"4px 8px",borderRadius:6,border:"1px solid #334155",background:"#0f172a",color:"#e2e8f0",fontSize:13,textAlign:"right"}}
                                                placeholder="0.00"/>
                                            {pct!==null&&<span style={{fontSize:12,fontWeight:600,minWidth:52,color:parseFloat(pct)>=0?C.bullish:C.bearish}}>{parseFloat(pct)>=0?"+":""}{pct}%</span>}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                        <div style={{marginTop:12}}>
                            <div style={{color:"#94a3b8",marginBottom:6,fontSize:12}}>Bildirim Tercihi:</div>
                            <div style={{display:"flex",gap:16}}>
                                {[["Mail",alarmMail,setAlarmMail],["Pop-up",alarmBildirim,setAlarmBildirim]].map(([ad,val,setter])=>(
                                    <label key={ad} style={{display:"flex",alignItems:"center",gap:6,cursor:"pointer",fontSize:13,color:"#e2e8f0"}}>
                                        <input type="checkbox" checked={val} onChange={e=>setter(e.target.checked)}/> {ad}
                                    </label>
                                ))}
                            </div>
                        </div>
                        <div style={{display:"flex",gap:8,marginTop:"1.25rem",justifyContent:"flex-end"}}>
                            <button onClick={()=>{setAlarmPopup(false);setAlarmHisseler([]);}}
                                style={{padding:"6px 16px",borderRadius:8,border:"1px solid #334155",background:"transparent",cursor:"pointer",fontSize:13,color:"#94a3b8"}}>Vazgeç</button>
                            <button onClick={alarmKaydet} disabled={alarmKaydediliyor}
                                style={{padding:"6px 16px",borderRadius:8,border:"none",background:alarmKaydediliyor?"#475569":"linear-gradient(135deg,#1d4ed8,#3b82f6)",color:"white",cursor:"pointer",fontSize:13}}>
                                {alarmKaydediliyor?"Kaydediliyor...":"Kaydet"}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {islemMenuAcik&&<div style={{position:"fixed",inset:0,zIndex:50}} onClick={()=>setIslemMenuAcik(false)}/>}
        </div>
    );
}


// ─── Çoklu Tarama Gönder yardımcıları ────────────────────────────────────────

const COKLU_MODULLER = [
    { label: "📊 Dip Tarama",           value: "Dip Tarama",                     pasif: false },
    { label: "🌊 Likidite Tarama",       value: "Likidite Tarama",                pasif: false },
    { label: "📈 FVG Tarama",            value: "FVG Tarama",                     pasif: false },
    { label: "⚓ Çapa Noktası Tarama",   value: "Çapa Noktası Tarama",            pasif: true  },
    { label: "📐 MSB Tarama",            value: "MSB Tarama",                     pasif: false },
    { label: "🎯 OTE Tarama",            value: "OTE Tarama",                     pasif: false },
    { label: "🧱 OB/BB Tarama",          value: "OB & BB Tarama",                 pasif: false },
    { label: "🎣 IDM Tarama",            value: "IDM Tarama",                     pasif: false },
    { label: "⚖️ P/D Zone Tarama",       value: "P/D Zone Tarama",               pasif: false },
    { label: "🔀 SMT Tarama",            value: "Korelasyonel Uyumsuzluk Tarama", pasif: false },
    { label: "⏰ Killzone Tarama",        value: "Killzone Tarama",               pasif: false },
    { label: "🌿 Topdown Cascade",        value: "Topdown Cascade",               pasif: false },
    { label: "📊 Hacim Profili Tarama",   value: "Hacim Profili Tarama",          pasif: false },
    { label: "🌊 Hacim Akışı Tarama",     value: "Hacim Akışı Tarama",            pasif: false },
    { label: "📉 Divergence Tarama",      value: "Divergence Tarama",             pasif: false },
];

const _PERIYOT_OPTS = ["1 Gün", "1 Hafta", "1 Ay", "3 Aylık", "6 Aylık", "Yıllık"];
const _KZ_LISTESI   = [
    "Asya KZ (03:00-09:00)", "Londra Açılış (10:00-12:00)", "New York Açılış (15:00-17:00)",
    "Londra Kapanış (18:00-20:00)", "BIST Açılış (10:00-11:00)",
    "BIST Öğle Dönüşü (13:00-14:00)", "BIST Kapanış Öncesi (17:00-18:00)",
];

function defaultCokluFiltreler(modul, piyasa) {
    switch (modul) {
        case "Dip Tarama":       return { tarama_periyot: "Aylık", tolerans: 1 };
        case "Likidite Tarama":  return { sweep_tipler: { "Boğa Sweep": true, "Ayı Sweep": false }, tarama_periyot: "1 Gün", lookback: 20, wick_oran: 50 };
        case "FVG Tarama":       return { fvg_tipler: { "Boğa FVG": true, "Ayı FVG": false, "iFVG": false }, bpr_kontrol: "Hayır", tarama_periyot: "1 Gün", mum_sayisi: 100 };
        case "MSB Tarama":       return { msb_tipler: { "Boğa MSB": true, "Ayı MSB": false }, tarama_periyot: "1 Ay", swing_pencere: 3 };
        case "OTE Tarama":       return { ote_tipler: { "Boğa OTE": true, "Ayı OTE": false }, tarama_periyot: "1 Hafta", swing_pencere: 3, mum_sayisi: 100 };
        case "OB & BB Tarama":   return { obbb_tipler: { "Boğa OB": true, "Ayı OB": false, "Boğa BB": false, "Ayı BB": false }, tarama_periyot: "1 Gün", mum_sayisi: 200, govde_oran: 60, sadece_taze: true };
        case "IDM Tarama":       return { idm_tipler: { "Boğa IDM": true, "Ayı IDM": false }, tarama_periyot: "1 Gün", mum_sayisi: 200 };
        case "P/D Zone Tarama":  return { bolge_filtre: { "Discount": true, "Equilibrium": false, "Premium": false }, tarama_periyot: "1 Gün", range_window: 20, mum_sayisi: 200 };
        case "SMT Tarama": return { smt_tipler: { "Boğa SMT": true, "Ayı SMT": false }, tarama_periyot: "1 Gün", referans_varlik: piyasa === "BIST" ? "XU100 (BIST100)" : "BTC", swing_pencere: 3, kor_pencere: 50, min_korelasyon: 70, mum_sayisi: 200 };
        case "Killzone Tarama":  return { killzoneler: { "BIST Açılış (10:00-11:00)": true }, yapi_tipleri: { "FVG": true, "MSB": false, "Sweep": false }, geri_bak_gun: 5 };
        case "Topdown Cascade":   return { topdown_mod: piyasa };
        case "Hacim Profili Tarama": return { tarama_periyot: "1 Gün", sinyal_filtre: [], min_skor: 0, mum_sayisi: 300 };
        case "Hacim Akışı Tarama": return { lookback: 20, min_spike: 1.5, sinyal_filtre: {"📈 Güçlü Alım":true,"🔶 Orta Alım":true,"⬇️ Zayıf Alım":false,"📉 Güçlü Satım":true,"🔶 Orta Satım":true,"⬆️ Zayıf Satım":false,"⚖️ Belirsiz":false} };
        case "Divergence Tarama": return { tarama_periyot: "1 Gün", pivot_modu: "fractal", osilatorler: {"RSI":true,"MACD Histogram":true,"Stokastik RSI":true,"OBV":false}, divergence_tipleri: {"Regular Bullish":true,"Regular Bearish":true,"Hidden Bullish":false,"Hidden Bearish":false}, swing_pencere:5, zigzag_esik:1, n_son_pivot:2, min_pivot_mesafe:3, min_hareket_atr:0, rsi_periyot:14, macd_fast:12, macd_slow:26, macd_signal:9, stoch_rsi_periyot:14, stoch_periyot:14, stoch_k:3, stoch_d:3, ayarlar_acik:false };
        default: return {};
    }
}

function CokluTaramaGonderPopup({ piyasa, paraBirimi, secilenSayisi, secilenModul, filtre, periyotlar, onModulSec, onFiltreDegis, onIptal, onBaslat }) {
    const periyotOpts = periyotlar && periyotlar.length > 0 ? periyotlar : _PERIYOT_OPTS;
    const set = (key, val) => onFiltreDegis({ ...filtre, [key]: val });
    const ck  = (grup, key) => onFiltreDegis({ ...filtre, [grup]: { ...filtre[grup], [key]: !filtre[grup][key] } });

    const CheckGrup = ({ alan, etiket }) => (
        <div style={{ marginBottom: "10px" }}>
            <div style={{ fontSize: "12px", fontWeight: "600", color: "#93c5fd", marginBottom: "6px" }}>{etiket}</div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
                {Object.keys(filtre[alan] || {}).map(k => (
                    <label key={k} style={{ display: "flex", alignItems: "center", gap: "4px", fontSize: "12px", cursor: "pointer" }}>
                        <input type="checkbox" checked={!!filtre[alan][k]} onChange={() => ck(alan, k)} />{k}
                    </label>
                ))}
            </div>
        </div>
    );

    const Sel = ({ alan, etiket, opts, labelFn }) => (
        <div style={{ marginBottom: "10px" }}>
            <div style={{ fontSize: "12px", fontWeight: "600", color: "#93c5fd", marginBottom: "6px" }}>{etiket}</div>
            <select value={filtre[alan]} onChange={e => set(alan, isNaN(e.target.value) ? e.target.value : Number(e.target.value))}
                style={{ padding: "6px 10px", borderRadius: "7px", border: "1px solid #334155", background: "#0f172a", color: "#e2e8f0", fontSize: "13px", width: "100%" }}>
                {opts.map(o => <option key={o} value={o}>{labelFn ? labelFn(o) : o}</option>)}
            </select>
        </div>
    );

    const renderFiltreler = () => {
        if (!filtre) return null;
        switch (secilenModul) {
            case "Dip Tarama":       return (<><Sel alan="tarama_periyot" etiket="Periyot" opts={periyotOpts} /><Sel alan="tolerans" etiket="Tolerans" opts={[1,3,5]} labelFn={v=>`%${v}`} /></>);
            case "Likidite Tarama":  return (<><CheckGrup alan="sweep_tipler" etiket="Sweep Tipi" /><Sel alan="tarama_periyot" etiket="Periyot" opts={periyotOpts} /><Sel alan="lookback" etiket="Lookback" opts={[10,20,50,100]} labelFn={v=>`${v} Mum`} /><Sel alan="wick_oran" etiket="Min Fitil" opts={[30,40,50,60,70]} labelFn={v=>`%${v}`} /></>);
            case "FVG Tarama":       return (<><CheckGrup alan="fvg_tipler" etiket="FVG Tipi" /><Sel alan="bpr_kontrol" etiket="BPR Kontrol" opts={["Evet","Hayır"]} /><Sel alan="tarama_periyot" etiket="Tarama Periyodu" opts={periyotOpts} /><Sel alan="mum_sayisi" etiket="Mum Sayısı" opts={[25,50,100,150,200,250,300,350,400,500,600,700]} /></>);
            case "MSB Tarama":       return (<><CheckGrup alan="msb_tipler" etiket="MSB Tipi" /><Sel alan="tarama_periyot" etiket="Periyot" opts={periyotOpts} /><Sel alan="swing_pencere" etiket="Swing Penceresi" opts={[2,3,4,5,6,7,8]} labelFn={v=>`${v} Mum`} /></>);
            case "OTE Tarama":       return (<><CheckGrup alan="ote_tipler" etiket="OTE Tipi" /><Sel alan="tarama_periyot" etiket="Tarama Periyodu" opts={periyotOpts} /><Sel alan="swing_pencere" etiket="Swing Penceresi" opts={[2,3,4,5,6,7,8]} labelFn={v=>`${v} Mum`} /><Sel alan="mum_sayisi" etiket="Mum Sayısı" opts={[50,100,150,200,300]} /></>);
            case "OB & BB Tarama":   return (<><CheckGrup alan="obbb_tipler" etiket="OB/BB Tipi" /><Sel alan="tarama_periyot" etiket="Periyot" opts={periyotOpts} /><Sel alan="mum_sayisi" etiket="Mum Sayısı" opts={[100,200,300,500]} /><Sel alan="govde_oran" etiket="Min Gövde" opts={[40,50,60,70]} labelFn={v=>`%${v}`} /><div style={{marginBottom:"10px"}}><label style={{display:"flex",alignItems:"center",gap:"6px",fontSize:"12px",cursor:"pointer"}}><input type="checkbox" checked={filtre.sadece_taze} onChange={e=>set("sadece_taze",e.target.checked)} />Sadece Taze</label></div></>);
            case "IDM Tarama":       return (<><CheckGrup alan="idm_tipler" etiket="IDM Tipi" /><Sel alan="tarama_periyot" etiket="Periyot" opts={periyotOpts} /><Sel alan="mum_sayisi" etiket="Mum Sayısı" opts={[100,200,300,500]} /></>);
            case "P/D Zone Tarama":  return (<><CheckGrup alan="bolge_filtre" etiket="Bölge" /><Sel alan="tarama_periyot" etiket="Periyot" opts={periyotOpts} /><Sel alan="range_window" etiket="Range Penceresi" opts={[10,20,50,100]} labelFn={v=>`${v} Mum`} /><Sel alan="mum_sayisi" etiket="Mum Sayısı" opts={[100,200,300,500]} /></>);
            case "SMT Tarama": return (<><CheckGrup alan="smt_tipler" etiket="SMT Tipi" /><Sel alan="tarama_periyot" etiket="Periyot" opts={periyotOpts} /><div style={{marginBottom:"10px"}}><div style={{fontSize:"12px",fontWeight:"600",color:"#93c5fd",marginBottom:"6px"}}>Referans Varlık</div><select value={filtre.referans_varlik} onChange={e=>set("referans_varlik",e.target.value)} style={{padding:"6px 10px",borderRadius:"7px",border:"1px solid #334155",background:"#0f172a",color:"#e2e8f0",fontSize:"13px",width:"100%"}}>{(piyasa==="BIST"?["XU100 (BIST100)","XU030 (BIST30)"]:["BTC","ETH","BNB"]).map(v=><option key={v}>{v}</option>)}</select></div><Sel alan="swing_pencere" etiket="Swing Penceresi" opts={[2,3,5]} labelFn={v=>`${v} Mum`} /><Sel alan="min_korelasyon" etiket="Min Korelasyon" opts={[50,60,70,80,90]} labelFn={v=>`%${v}`} /><Sel alan="mum_sayisi" etiket="Mum Sayısı" opts={[100,200,300]} /></>);
            case "Killzone Tarama":  return (<><div style={{marginBottom:"10px"}}><div style={{fontSize:"12px",fontWeight:"600",color:"#93c5fd",marginBottom:"6px"}}>Killzone</div><div style={{display:"flex",flexWrap:"wrap",gap:"8px"}}>{_KZ_LISTESI.filter(k=>piyasa==="BIST"||!k.includes("BIST")).map(k=><label key={k} style={{display:"flex",alignItems:"center",gap:"4px",fontSize:"12px",cursor:"pointer"}}><input type="checkbox" checked={!!filtre.killzoneler[k]} onChange={()=>ck("killzoneler",k)} />{k.split("(")[0].trim()}</label>)}</div></div><div style={{marginBottom:"10px"}}><div style={{fontSize:"12px",fontWeight:"600",color:"#93c5fd",marginBottom:"6px"}}>Yapı Tipi</div><div style={{display:"flex",gap:"12px"}}>{["FVG","MSB","Sweep"].map(k=><label key={k} style={{display:"flex",alignItems:"center",gap:"4px",fontSize:"12px",cursor:"pointer"}}><input type="checkbox" checked={!!filtre.yapi_tipleri[k]} onChange={()=>ck("yapi_tipleri",k)} />{k}</label>)}</div></div><Sel alan="geri_bak_gun" etiket="Geriye Bakış" opts={[1,3,5,10]} labelFn={v=>`Son ${v} Gün`} /></>);
            case "Topdown Cascade": return (<div style={{fontSize:"13px",color:"#94a3b8",padding:"8px 0"}}>{piyasa} — EMA200 + 4H Sweep taraması. Ek kriter seçimi gerekmez.</div>);
            case "Hacim Profili Tarama": {
                const HP_SF = ["POC Yakını","Discount","Premium","HVN Yakın","LVN İçi"];
                const hpSF = filtre.sinyal_filtre || [];
                const toggleHpSF = v => { const sf = Array.isArray(hpSF)?hpSF:[]; set("sinyal_filtre", sf.includes(v)?sf.filter(x=>x!==v):[...sf,v]); };
                return (<>
                    <Sel alan="tarama_periyot" etiket="Periyot" opts={periyotOpts} />
                    <div style={{marginBottom:"10px"}}><div style={{fontSize:"12px",fontWeight:"600",color:"#93c5fd",marginBottom:"6px"}}>Sinyal Filtresi</div>
                        <div style={{display:"flex",flexWrap:"wrap",gap:"6px"}}>{HP_SF.map(v=>{const aktif=Array.isArray(hpSF)&&hpSF.includes(v);return(<button key={v} type="button" onClick={()=>toggleHpSF(v)} style={{padding:"3px 10px",borderRadius:20,fontSize:11,cursor:"pointer",fontWeight:aktif?600:400,border:`1px solid ${aktif?"#3b82f6":"#334155"}`,background:aktif?"#3b82f622":"transparent",color:aktif?"#3b82f6":"#94a3b8"}}>{v}</button>);})}</div>
                    </div>
                    <Sel alan="min_skor" etiket="Min Skor" opts={[0,2,3,4,5,6,7]} labelFn={v=>v===0?"Tümü":`≥${v}`} />
                    <Sel alan="mum_sayisi" etiket="Mum Sayısı" opts={[100,200,300,500]} />
                </>);
            }
            case "Hacim Akışı Tarama": {
                const HA_RENK_MAP = {"📈 Güçlü Alım":"#16a34a","🔶 Orta Alım":"#84cc16","⬇️ Zayıf Alım":"#a3e635","📉 Güçlü Satım":"#dc2626","🔶 Orta Satım":"#f97316","⬆️ Zayıf Satım":"#fca5a5","⚖️ Belirsiz":"#9ca3af"};
                const haSF = (typeof filtre.sinyal_filtre==="object"&&!Array.isArray(filtre.sinyal_filtre)) ? filtre.sinyal_filtre : {};
                const toggleHA = s => set("sinyal_filtre",{...haSF,[s]:!haSF[s]});
                return (<>
                    <div style={{marginBottom:"10px"}}><div style={{fontSize:"12px",fontWeight:"600",color:"#93c5fd",marginBottom:"6px"}}>Ort. Pencere (Gün)</div>
                        <select value={filtre.lookback||20} onChange={e=>set("lookback",Number(e.target.value))} style={{padding:"6px 10px",borderRadius:"7px",border:"1px solid #334155",background:"#0f172a",color:"#e2e8f0",fontSize:"13px",width:"100%"}}>
                            {[5,10,20,30,40,50].map(v=><option key={v} value={v}>{v} Gün</option>)}
                        </select>
                    </div>
                    <div style={{marginBottom:"10px"}}><div style={{fontSize:"12px",fontWeight:"600",color:"#93c5fd",marginBottom:"6px"}}>Min. Spike (×Ort.)</div>
                        <input type="number" value={filtre.min_spike||1.5} min={1.0} max={10} step={0.1} onChange={e=>set("min_spike",parseFloat(e.target.value))} style={{padding:"6px 10px",borderRadius:"7px",border:"1px solid #334155",background:"#0f172a",color:"#e2e8f0",fontSize:"13px",width:"70px"}}/>
                    </div>
                    <div style={{marginBottom:"10px"}}><div style={{fontSize:"12px",fontWeight:"600",color:"#93c5fd",marginBottom:"6px"}}>Sinyal Tipi</div>
                        <div style={{display:"flex",gap:8}}>
                            <div style={{background:"#0f172a",border:"1px solid #16a34a55",borderRadius:6,padding:"6px 10px",flex:1}}>
                                <div style={{fontSize:10,fontWeight:700,color:"#16a34a",marginBottom:4}}>📈 ALIMLAR</div>
                                {["📈 Güçlü Alım","🔶 Orta Alım","⬇️ Zayıf Alım","⚖️ Belirsiz"].map(s=>{const aktif=!!haSF[s];return(<button key={s} type="button" onClick={()=>toggleHA(s)} style={{display:"block",width:"100%",textAlign:"left",padding:"2px 6px",borderRadius:4,marginBottom:2,cursor:"pointer",fontSize:11,fontWeight:aktif?700:400,background:aktif?HA_RENK_MAP[s]+"22":"transparent",border:`1px solid ${aktif?HA_RENK_MAP[s]:"transparent"}`,color:aktif?HA_RENK_MAP[s]:"#94a3b8"}}>{s}</button>);})}
                            </div>
                            <div style={{background:"#0f172a",border:"1px solid #dc262655",borderRadius:6,padding:"6px 10px",flex:1}}>
                                <div style={{fontSize:10,fontWeight:700,color:"#dc2626",marginBottom:4}}>📉 SATIMLAR</div>
                                {["📉 Güçlü Satım","🔶 Orta Satım","⬆️ Zayıf Satım"].map(s=>{const aktif=!!haSF[s];return(<button key={s} type="button" onClick={()=>toggleHA(s)} style={{display:"block",width:"100%",textAlign:"left",padding:"2px 6px",borderRadius:4,marginBottom:2,cursor:"pointer",fontSize:11,fontWeight:aktif?700:400,background:aktif?HA_RENK_MAP[s]+"22":"transparent",border:`1px solid ${aktif?HA_RENK_MAP[s]:"transparent"}`,color:aktif?HA_RENK_MAP[s]:"#94a3b8"}}>{s}</button>);})}
                            </div>
                        </div>
                    </div>
                </>);
            }
            case "Divergence Tarama": {
                const DIV_OSC = ["RSI","MACD Histogram","Stokastik RSI","OBV"];
                const DIV_TIPLER = [{key:"Regular Bullish",ikon:"📈",renk:"#16a34a"},{key:"Regular Bearish",ikon:"📉",renk:"#dc2626"},{key:"Hidden Bullish",ikon:"🔼",renk:"#06b6d4"},{key:"Hidden Bearish",ikon:"🔽",renk:"#f59e0b"}];
                const divOsc = filtre.osilatorler || {};
                const divTip = filtre.divergence_tipleri || {};
                const toggleOsc = o => set("osilatorler",{...divOsc,[o]:!divOsc[o]});
                const toggleTip = t => set("divergence_tipleri",{...divTip,[t]:!divTip[t]});
                const ayarlarAcik = filtre.ayarlar_acik||false;
                const stochAktif = !!divOsc["Stokastik RSI"], macdAktif = !!divOsc["MACD Histogram"], rsiAktif = !!divOsc["RSI"];
                return (<>
                    <Sel alan="tarama_periyot" etiket="Periyot" opts={periyotOpts} />
                    <div style={{marginBottom:"10px"}}><div style={{fontSize:"12px",fontWeight:"600",color:"#93c5fd",marginBottom:"6px"}}>Pivot Modu</div>
                        <div style={{display:"flex",gap:6}}>{[["fractal","Fractal"],["zigzag","ZigZag"]].map(([v,l])=>{const aktif=(filtre.pivot_modu||"fractal")===v;return(<button key={v} type="button" onClick={()=>set("pivot_modu",v)} style={{padding:"5px 12px",borderRadius:8,fontSize:12,fontWeight:600,cursor:"pointer",border:`1px solid ${aktif?"#3b82f6":"#334155"}`,background:aktif?"#3b82f622":"#0f172a",color:aktif?"#3b82f6":"#94a3b8"}}>{l}</button>);})}</div>
                    </div>
                    <div style={{marginBottom:"10px"}}><div style={{fontSize:"12px",fontWeight:"600",color:"#93c5fd",marginBottom:"6px"}}>Osilatörler</div>
                        <div style={{display:"flex",flexWrap:"wrap",gap:6}}>{DIV_OSC.map(o=>{const aktif=!!divOsc[o];return(<button key={o} type="button" onClick={()=>toggleOsc(o)} style={{padding:"4px 10px",borderRadius:8,fontSize:11,cursor:"pointer",fontWeight:aktif?600:400,border:`1px solid ${aktif?"#3b82f6":"#334155"}`,background:aktif?"#3b82f618":"#0f172a",color:aktif?"#3b82f6":"#94a3b8"}}>{o}</button>);})}</div>
                    </div>
                    <div style={{marginBottom:"10px"}}><div style={{fontSize:"12px",fontWeight:"600",color:"#93c5fd",marginBottom:"6px"}}>Divergence Tipleri</div>
                        <div style={{display:"flex",flexWrap:"wrap",gap:6}}>{DIV_TIPLER.map(t=>{const aktif=!!divTip[t.key];return(<button key={t.key} type="button" onClick={()=>toggleTip(t.key)} style={{padding:"4px 10px",borderRadius:8,fontSize:11,cursor:"pointer",fontWeight:aktif?600:400,border:`1px solid ${aktif?t.renk:"#334155"}`,background:aktif?t.renk+"18":"#0f172a",color:aktif?t.renk:"#94a3b8"}}>{t.ikon} {t.key}</button>);})}</div>
                    </div>
                    <button type="button" onClick={()=>set("ayarlar_acik",!ayarlarAcik)} style={{padding:"5px 12px",borderRadius:8,border:"1px solid #334155",background:ayarlarAcik?"#334155":"#0f172a",color:"#e2e8f0",fontSize:11,fontWeight:600,cursor:"pointer",marginBottom:8}}>⚙️ Gelişmiş Ayarlar {ayarlarAcik?"▲":"▼"}</button>
                    {ayarlarAcik && (<div style={{display:"flex",flexWrap:"wrap",gap:8,marginBottom:8}}>
                        {(filtre.pivot_modu||"fractal")==="fractal"
                            ? (<div><div style={{fontSize:11,color:"#93c5fd",marginBottom:4}}>Swing Penceresi</div><input type="number" value={filtre.swing_pencere||5} min={2} max={20} onChange={e=>set("swing_pencere",parseInt(e.target.value))} style={{padding:"4px 8px",borderRadius:6,border:"1px solid #334155",background:"#0f172a",color:"#e2e8f0",fontSize:12,width:65}}/></div>)
                            : (<div><div style={{fontSize:11,color:"#93c5fd",marginBottom:4}}>ZigZag Eşik (%)</div><input type="number" value={filtre.zigzag_esik||1} min={0.5} max={20} step={0.5} onChange={e=>set("zigzag_esik",parseFloat(e.target.value))} style={{padding:"4px 8px",borderRadius:6,border:"1px solid #334155",background:"#0f172a",color:"#e2e8f0",fontSize:12,width:65}}/></div>)
                        }
                        <div><div style={{fontSize:11,color:"#93c5fd",marginBottom:4}}>N Son Pivot</div><div style={{display:"flex",gap:4}}>{[2,3].map(n=>{const a=(filtre.n_son_pivot||2)===n;return(<button key={n} type="button" onClick={()=>set("n_son_pivot",n)} style={{padding:"4px 8px",borderRadius:6,fontSize:12,cursor:"pointer",border:`1px solid ${a?"#3b82f6":"#334155"}`,background:a?"#3b82f622":"#0f172a",color:a?"#3b82f6":"#94a3b8"}}>{n}</button>);})}</div></div>
                        <div><div style={{fontSize:11,color:"#93c5fd",marginBottom:4}}>Min Pivot Mesafe</div><input type="number" value={filtre.min_pivot_mesafe||3} min={0} max={20} onChange={e=>set("min_pivot_mesafe",parseInt(e.target.value))} style={{padding:"4px 8px",borderRadius:6,border:"1px solid #334155",background:"#0f172a",color:"#e2e8f0",fontSize:12,width:65}}/></div>
                        <div><div style={{fontSize:11,color:"#93c5fd",marginBottom:4}}>Min Hareket (xATR)</div><input type="number" value={filtre.min_hareket_atr||0} min={0} max={5} step={0.1} onChange={e=>set("min_hareket_atr",parseFloat(e.target.value))} style={{padding:"4px 8px",borderRadius:6,border:"1px solid #334155",background:"#0f172a",color:"#e2e8f0",fontSize:12,width:65}}/></div>
                        {rsiAktif && <div><div style={{fontSize:11,color:"#93c5fd",marginBottom:4}}>RSI Periyot</div><input type="number" value={filtre.rsi_periyot||14} min={2} max={50} onChange={e=>set("rsi_periyot",parseInt(e.target.value))} style={{padding:"4px 8px",borderRadius:6,border:"1px solid #334155",background:"#0f172a",color:"#e2e8f0",fontSize:12,width:65}}/></div>}
                        {macdAktif && <><div><div style={{fontSize:11,color:"#93c5fd",marginBottom:4}}>MACD Fast</div><input type="number" value={filtre.macd_fast||12} min={2} max={50} onChange={e=>set("macd_fast",parseInt(e.target.value))} style={{padding:"4px 8px",borderRadius:6,border:"1px solid #334155",background:"#0f172a",color:"#e2e8f0",fontSize:12,width:65}}/></div><div><div style={{fontSize:11,color:"#93c5fd",marginBottom:4}}>MACD Slow</div><input type="number" value={filtre.macd_slow||26} min={5} max={100} onChange={e=>set("macd_slow",parseInt(e.target.value))} style={{padding:"4px 8px",borderRadius:6,border:"1px solid #334155",background:"#0f172a",color:"#e2e8f0",fontSize:12,width:65}}/></div><div><div style={{fontSize:11,color:"#93c5fd",marginBottom:4}}>MACD Signal</div><input type="number" value={filtre.macd_signal||9} min={2} max={50} onChange={e=>set("macd_signal",parseInt(e.target.value))} style={{padding:"4px 8px",borderRadius:6,border:"1px solid #334155",background:"#0f172a",color:"#e2e8f0",fontSize:12,width:65}}/></div></>}
                        {stochAktif && <><div><div style={{fontSize:11,color:"#93c5fd",marginBottom:4}}>StochRSI RSI Per.</div><input type="number" value={filtre.stoch_rsi_periyot||14} min={2} max={50} onChange={e=>set("stoch_rsi_periyot",parseInt(e.target.value))} style={{padding:"4px 8px",borderRadius:6,border:"1px solid #334155",background:"#0f172a",color:"#e2e8f0",fontSize:12,width:65}}/></div><div><div style={{fontSize:11,color:"#93c5fd",marginBottom:4}}>StochRSI Stoch Per.</div><input type="number" value={filtre.stoch_periyot||14} min={2} max={50} onChange={e=>set("stoch_periyot",parseInt(e.target.value))} style={{padding:"4px 8px",borderRadius:6,border:"1px solid #334155",background:"#0f172a",color:"#e2e8f0",fontSize:12,width:65}}/></div><div><div style={{fontSize:11,color:"#93c5fd",marginBottom:4}}>%K</div><input type="number" value={filtre.stoch_k||3} min={1} max={20} onChange={e=>set("stoch_k",parseInt(e.target.value))} style={{padding:"4px 8px",borderRadius:6,border:"1px solid #334155",background:"#0f172a",color:"#e2e8f0",fontSize:12,width:55}}/></div><div><div style={{fontSize:11,color:"#93c5fd",marginBottom:4}}>%D</div><input type="number" value={filtre.stoch_d||3} min={1} max={20} onChange={e=>set("stoch_d",parseInt(e.target.value))} style={{padding:"4px 8px",borderRadius:6,border:"1px solid #334155",background:"#0f172a",color:"#e2e8f0",fontSize:12,width:55}}/></div></>}
                    </div>)}
                </>);
            }
            default: return null;
        }
    };

    return (
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.55)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:1000}}>
            <div style={{background:"#1e293b",border:"1px solid #334155",borderRadius:"14px",padding:"1.75rem",width:"500px",maxWidth:"95vw",maxHeight:"85vh",overflowY:"auto",boxShadow:"0 12px 48px rgba(0,0,0,0.5)",color:"#e2e8f0"}}>
                <div style={{fontSize:"18px",fontWeight:"700",color:"#e2e8f0",marginBottom:"0.5rem"}}>🔗 Çoklu Taramaya Gönder</div>
                <p style={{fontSize:"13px",color:"#94a3b8",marginBottom:"1.25rem"}}>
                    <strong>{secilenSayisi}</strong> hisse seçili. Devam edilecek modülü ve kriterleri seçin.
                </p>
                <div style={{marginBottom:"1.25rem"}}>
                    <div style={{fontSize:"12px",fontWeight:"600",color:"#93c5fd",marginBottom:"8px"}}>Modül Seçin</div>
                    <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"6px"}}>
                        {COKLU_MODULLER.map(m => (
                            <button key={m.value} type="button" disabled={m.pasif} onClick={() => !m.pasif && onModulSec(m.value)}
                                style={{padding:"8px 10px",borderRadius:"8px",border:"2px solid",
                                    borderColor:secilenModul===m.value?"#3b82f6":m.pasif?"#1e293b":"#334155",
                                    background: secilenModul===m.value?"#1d4ed822":m.pasif?"#0f172a":"#0f172a",
                                    color:m.pasif?"#475569":secilenModul===m.value?"#93c5fd":"#e2e8f0",
                                    cursor:m.pasif?"default":"pointer",
                                    fontSize:"12px",fontWeight:secilenModul===m.value?"600":"400",textAlign:"left"}}>
                                {m.label}
                                {m.pasif && <span style={{fontSize:"10px",marginLeft:"4px",color:"#d1d5db"}}>(Mevcut)</span>}
                            </button>
                        ))}
                    </div>
                </div>
                {secilenModul && (
                    <div style={{background:"#0f172a",border:"1px solid #334155",borderRadius:"8px",padding:"10px 14px",marginBottom:"1rem",display:"flex",gap:"20px"}}>
                        <div><div style={{fontSize:"11px",color:"#9ca3af",fontWeight:"500"}}>Piyasa</div><div style={{fontSize:"13px",fontWeight:"600",color:"#e2e8f0"}}>🔒 {piyasa}</div></div>
                        <div><div style={{fontSize:"11px",color:"#9ca3af",fontWeight:"500"}}>Para Birimi</div><div style={{fontSize:"13px",fontWeight:"600",color:"#e2e8f0"}}>🔒 {paraBirimi}</div></div>
                    </div>
                )}
                {secilenModul && filtre && (
                    <div style={{marginBottom:"1.25rem"}}>
                        <div style={{fontSize:"12px",fontWeight:"600",color:"#93c5fd",marginBottom:"10px"}}>Tarama Kriterleri</div>
                        {renderFiltreler()}
                    </div>
                )}
                <div style={{display:"flex",gap:"8px",justifyContent:"flex-end"}}>
                    <button onClick={onIptal} style={{padding:"8px 18px",borderRadius:"8px",border:"1px solid #334155",background:"transparent",cursor:"pointer",fontSize:"13px",color:"#94a3b8"}}>İptal</button>
                    <button onClick={onBaslat} disabled={!secilenModul}
                        style={{padding:"8px 20px",borderRadius:"8px",border:"none",background:secilenModul?"linear-gradient(135deg,#1d4ed8,#3b82f6)":"#475569",color:"white",cursor:secilenModul?"pointer":"default",fontSize:"13px",fontWeight:"600"}}>
                        Taramayı Başlat →
                    </button>
                </div>
            </div>
        </div>
    );
}





// ─── Mini Türkçe Takvim (Popup için) ──────────────────────────────────────────
const _TR_AYLAR = ["Ocak","Şubat","Mart","Nisan","Mayıs","Haziran",
                   "Temmuz","Ağustos","Eylül","Ekim","Kasım","Aralık"];

function MiniTakvim({ value, onChange }) {
    const bugun = new Date(); bugun.setHours(0,0,0,0);
    const [gorunenYil, setGorunenYil] = useState(bugun.getFullYear());
    const [gorunenAy,  setGorunenAy]  = useState(bugun.getMonth());
    const [yilMod,     setYilMod]     = useState(false);
    const [ayMod,      setAyMod]      = useState(false);

    const seciliTarih = value ? (() => { const d = new Date(value + "T00:00:00"); d.setHours(0,0,0,0); return d; })() : null;
    const baslangicGun = (new Date(gorunenYil, gorunenAy, 1).getDay() + 6) % 7;
    const gunSayisi    = new Date(gorunenYil, gorunenAy + 1, 0).getDate();
    const gunler = [];
    for (let i = 0; i < baslangicGun; i++) gunler.push(null);
    for (let d = 1; d <= gunSayisi; d++) gunler.push(d);

    const gunSec = gun => {
        if (!gun) return;
        const t = new Date(gorunenYil, gorunenAy, gun); t.setHours(0,0,0,0);
        if (t >= bugun) return;
        onChange(`${gorunenYil}-${String(gorunenAy+1).padStart(2,"0")}-${String(gun).padStart(2,"0")}`);
    };
    const oncekiAy = () => {
        if (gorunenAy === 0) { setGorunenYil(y => y-1); setGorunenAy(11); }
        else setGorunenAy(m => m-1);
    };
    const sonrakiAy = () => {
        const ny = gorunenAy === 11 ? 0 : gorunenAy+1;
        const fy = gorunenAy === 11 ? gorunenYil+1 : gorunenYil;
        if (new Date(fy, ny, 1) >= bugun) return;
        setGorunenAy(ny); setGorunenYil(fy);
    };
    const yillar = [];
    for (let y = bugun.getFullYear(); y >= 1990; y--) yillar.push(y);
    const sonrakiDevre = new Date(gorunenAy === 11 ? gorunenYil+1 : gorunenYil, gorunenAy === 11 ? 0 : gorunenAy+1, 1) >= bugun;

    return (
        <div style={{border:"1px solid #334155", borderRadius:"10px", padding:"12px", background:"#0f172a", userSelect:"none"}}>
            <div style={{display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:"8px"}}>
                <button type="button" onClick={oncekiAy} style={_navBtn}>&#8249;</button>
                <div style={{display:"flex", gap:"4px"}}>
                    <div style={{position:"relative"}}>
                        <button type="button" onClick={() => { setAyMod(v=>!v); setYilMod(false); }}
                            style={{fontWeight:"600", fontSize:"13px", color:"#93c5fd",
                                    background: ayMod ? "#1e293b" : "none",
                                    border: ayMod ? "1px solid #334155" : "1px solid transparent",
                                    cursor:"pointer", padding:"2px 7px", borderRadius:"5px"}}>
                            {_TR_AYLAR[gorunenAy]} &#9662;
                        </button>
                        {ayMod && (
                            <div style={{position:"absolute", top:"calc(100% + 3px)", left:"50%",
                                         transform:"translateX(-50%)", zIndex:700, background:"#1e293b",
                                         borderRadius:"8px", boxShadow:"0 4px 16px rgba(0,0,0,0.15)",
                                         border:"1px solid #334155", padding:"6px",
                                         display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:"3px", minWidth:"175px"}}>
                                {_TR_AYLAR.map((ay, i) => {
                                    const dev = new Date(gorunenYil, i, 1) >= bugun;
                                    return (
                                        <button key={ay} type="button" disabled={dev}
                                            onClick={() => { setGorunenAy(i); setAyMod(false); }}
                                            style={{padding:"5px 3px", borderRadius:"5px", border:"none",
                                                    fontSize:"11px", cursor: dev ? "default" : "pointer",
                                                    background: i === gorunenAy ? "#2563eb" : "transparent",
                                                    color: i === gorunenAy ? "white" : dev ? "#475569" : "#e2e8f0",
                                                    fontWeight: i === gorunenAy ? "600" : "400"}}>
                                            {ay.slice(0,3)}
                                        </button>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                    <div style={{position:"relative"}}>
                        <button type="button" onClick={() => { setYilMod(v=>!v); setAyMod(false); }}
                            style={{fontWeight:"600", fontSize:"13px", color:"#93c5fd",
                                    background: yilMod ? "#1e293b" : "none",
                                    border: yilMod ? "1px solid #334155" : "1px solid transparent",
                                    cursor:"pointer", padding:"2px 7px", borderRadius:"5px"}}>
                            {gorunenYil} &#9662;
                        </button>
                        {yilMod && (
                            <div style={{position:"absolute", top:"calc(100% + 3px)", left:"50%",
                                         transform:"translateX(-50%)", zIndex:700, background:"#1e293b",
                                         borderRadius:"8px", boxShadow:"0 4px 16px rgba(0,0,0,0.15)",
                                         border:"1px solid #334155", maxHeight:"160px", color:"#e2e8f0", overflowY:"auto", minWidth:"75px"}}>
                                {yillar.map(y => (
                                    <button key={y} type="button" onClick={() => { setGorunenYil(y); setYilMod(false); }}
                                        style={{display:"block", width:"100%", padding:"5px 12px", border:"none",
                                                textAlign:"center", fontSize:"12px", cursor:"pointer",
                                                background: y === gorunenYil ? "#2563eb" : "transparent",
                                                color: y === gorunenYil ? "white" : "#e2e8f0",
                                                fontWeight: y === gorunenYil ? "600" : "400"}}>
                                        {y}
                                    </button>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
                <button type="button" onClick={sonrakiAy}
                    style={{..._navBtn, opacity: sonrakiDevre ? 0.3 : 1, cursor: sonrakiDevre ? "default" : "pointer"}}>&#8250;</button>
            </div>
            <div style={{display:"grid", gridTemplateColumns:"repeat(7,1fr)", gap:"1px", marginBottom:"3px"}}>
                {["Pt","Sa","Ça","Pe","Cu","Ct","Pz"].map(g => (
                    <div key={g} style={{textAlign:"center", fontSize:"10px", color:"#9ca3af", fontWeight:"600", padding:"2px"}}>{g}</div>
                ))}
            </div>
            <div style={{display:"grid", gridTemplateColumns:"repeat(7,1fr)", gap:"1px"}}>
                {gunler.map((gun, i) => {
                    if (!gun) return <div key={"e"+i} />;
                    const t = new Date(gorunenYil, gorunenAy, gun); t.setHours(0,0,0,0);
                    const gelecek = t >= bugun;
                    const secili  = seciliTarih && t.getTime() === seciliTarih.getTime();
                    const bugunku = t.getTime() === bugun.getTime();
                    return (
                        <button key={gun} type="button" onClick={() => gunSec(gun)} disabled={gelecek}
                            style={{padding:"4px 2px", border:"none", borderRadius:"5px",
                                    fontSize:"11px", cursor: gelecek ? "default" : "pointer",
                                    background: secili ? "#2563eb" : bugunku ? "#1e3a5f" : "transparent",
                                    color: secili ? "white" : gelecek ? "#475569" : bugunku ? "#93c5fd" : "#e2e8f0",
                                    fontWeight: secili || bugunku ? "700" : "400"}}>
                            {gun}
                        </button>
                    );
                })}
            </div>
            <div style={{borderTop:"1px solid #334155", marginTop:"8px", paddingTop:"7px",
                         display:"flex", gap:"4px", flexWrap:"wrap"}}>
                {[["1 Ay",1],["3 Ay",3],["6 Ay",6],["1 Yıl",12],["2 Yıl",24],["3 Yıl",36]].map(([label, ay]) => (
                    <button key={label} type="button" onClick={() => {
                        const d = new Date(bugun); d.setMonth(d.getMonth() - ay);
                        const iso = d.toISOString().split("T")[0];
                        onChange(iso); setGorunenYil(d.getFullYear()); setGorunenAy(d.getMonth());
                    }} style={{padding:"2px 8px", borderRadius:"10px", fontSize:"10px",
                               border:"1px solid #334155", background:"#1e293b", cursor:"pointer", color:"#e2e8f0"}}>
                        {label}
                    </button>
                ))}
            </div>
            {value && (
                <div style={{textAlign:"center", marginTop:"8px", paddingTop:"7px",
                             borderTop:"1px solid #334155", fontSize:"12px", color:"#93c5fd", fontWeight:"600"}}>
                    {(() => { const d = new Date(value + "T00:00:00");
                        return String(d.getDate()).padStart(2,"0") + " " + _TR_AYLAR[d.getMonth()] + " " + d.getFullYear(); })()}
                </div>
            )}
        </div>
    );
}
const _navBtn = {padding:"3px 9px", border:"1px solid #334155", borderRadius:"5px",
                 background:"#1e293b", cursor:"pointer", fontSize:"15px", color:"#e2e8f0", lineHeight:"1"};



const popupStyles = {
    overlay:   {position:"fixed",inset:0,background:"rgba(0,0,0,0.7)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:1000},
    modal:     {background:"#1e293b",border:"1px solid #334155",borderRadius:"14px",padding:"2rem",width:"480px",maxWidth:"95vw",boxShadow:"0 12px 48px rgba(0,0,0,0.5)",color:"#e2e8f0"},
    baslik:    {fontSize:"18px",fontWeight:"700",color:"#e2e8f0",marginBottom:"0.75rem"},
    btnVazgec: {padding:"8px 18px",borderRadius:"8px",border:"1px solid #334155",background:"transparent",cursor:"pointer",fontSize:"13px",color:"#94a3b8"},
    btnPrimary:{padding:"8px 20px",borderRadius:"8px",border:"none",background:"linear-gradient(135deg,#1d4ed8,#3b82f6)",color:"white",cursor:"pointer",fontSize:"13px",fontWeight:"600"},
};
